const translation = {
  errorBoundary: {
    title: 'Er ging iets mis',
    description: 'Deze pagina kon niet worden getoond. Je gegevens zijn niet gewijzigd. Probeer het opnieuw of herlaad de pagina.',
    offlineTitle: 'We kunnen het platform niet bereiken',
    offlineDescription: 'De verbinding met het platform is mislukt. Controleer je internetverbinding en probeer het opnieuw.',
    retry: 'Opnieuw proberen',
    reload: 'Pagina herladen',
  },
  notifications: {
    empty: 'Geen nieuwe meldingen',
    clearAll: 'Alles wissen',
    clearAllConfirm: 'Alle meldingen wissen? Dit kan niet ongedaan worden gemaakt.',
    clearAllFailed: 'Meldingen wissen is mislukt',
    markReadFailed: 'Melding kon niet als gelezen worden gemarkeerd',
    delete: 'Melding verwijderen',
    deleteFailed: 'Melding verwijderen is mislukt',
    reminderTitle: 'Meting bijna nodig',
    reminderBody: 'Het is bijna tijd om {{measurement}} te registreren voor {{programme}}.',
    cleared: 'Meldingen gewist',
    deleted: 'Melding verwijderd',
  },
  dataGrid: {
    noResultsFound: 'Geen resultaten gevonden',
    selectAll: 'Alles selecteren',
    selectRow: '{{name}} selecteren',
    rowLabel: 'rij {{id}}',
    ascending: 'Oplopend',
    descending: 'Aflopend',
    sortByColumn: 'Sorteren op {{column}} ({{direction}})',
  },
  manageUsers: {
    title: 'Leden van de organisatie',
    subtitle: 'De mensen in je organisatie, en welke rol ze hier hebben.',
    nameColumn: 'Naam',
    emailColumn: 'E-mail',
    rolesColumn: 'Rollen',
    rolesPlaceholder: 'Rol toevoegen',
    rolesSaved: 'Rollen bijgewerkt',
    rolesFailed: 'De rollen konden niet worden bijgewerkt',
    rolesPartlySaved: 'Een deel van de wijziging is opgeslagen. De rest is geweigerd: {{reason}}',
    filterLabel: 'Rol',
    filterAll: 'Iedereen',
    filterNone: 'Zonder rol',
    noTenantNotice: 'Leden staan per organisatie, en dit account hoort bij geen enkele.',
    noTenantTitle: 'Nog geen organisatie',
    noRoles: 'Geen rol',
    add: {
      button: 'Persoon toevoegen',
      title: 'Een persoon toevoegen',
      address: 'E-mail of referentiecode',
      addressHelp: 'Het precieze adres of de code die de persoon je gaf.',
      addressRequired: 'Typ een e-mailadres of referentiecode',
      lookUp: 'Opzoeken',
      save: 'Toevoegen',
      found: 'Gevonden: {{name}}. Wil je deze persoon toevoegen?',
      alreadyMember: '{{name}} is al lid.',
      notFound: 'Er is nog geen account met dit adres of deze code. Iemand verschijnt na de eerste keer inloggen.',
      lookupFailed: 'Het adres kon niet worden opgezocht.',
      failed: 'De persoon kon niet worden toegevoegd.',
      added: '{{name}} is toegevoegd',
    },
    roles: {
      action: 'Rollen',
      title: 'Rollen van {{name}}',
    },
    disconnect: {
      action: 'Ontkoppelen',
      title: 'Lid ontkoppelen',
      message: '{{name}} is dan geen lid meer van {{tenant}}. Hun rollen hier vervallen en hun programma’s hier stoppen.',
      done: '{{name}} is ontkoppeld',
      notYourself: 'Je kunt jezelf niet ontkoppelen.',
      lastAdmin: 'Dit is de laatste beheerder van deze organisatie.',
    },
  },
  // Navigation
  navGroups: {
    general: 'Algemeen',
    programmes: 'Programma\'s',
    mySettings: 'Instellingen',
    roles: 'Rollen',
  },
  navigation: {
    ownEnvironment: 'Mijn eigen omgeving',
    platformEnvironment: 'Platformbeheer',
    switchEnvironment: 'Wissel van omgeving',
    manageUsers: 'Leden van de organisatie',
    dashboard: 'Mijn Dashboard',
    foodTracking: 'Voeding Bijhouden',
    activity: 'Activiteit',
    sleep: 'Slaap',
    weightBmi: 'Gewicht/BMI',
    wellnessValues: 'Welzijn Waarden',
    progress: 'Voortgang',
    insights: 'Inzichten',
    myCommunity: 'Mijn Gemeenschap',
    coaches: 'Coaches',
    coaching: 'Coaching',
    myProgrammes: 'Mijn Programma\'s',
    programs: 'Programma\'s',
    researchData: 'Onderzoeksgegevens',
    education: 'Educatie',
    analytics: 'Analytics',
    billing: 'Facturering',
    shareData: 'Gegevens Delen',
    settings: 'Taal en regio',
    profile: 'Mijn Profiel',
    dataPermissions: 'Gegevenstoestemmingen',
    logout: 'Uitloggen',
    masterData: 'Stamgegevens',
    metabolicMeasurements: 'Mijn Metingen',
    weeklyData: 'Wekelijkse Gegevens',
    tenantSettings: 'Tenant Instellingen',
    dataManagement: 'Stamgegevens',
    manageProgrammes: 'Programma-instellingen',
    manageProgrammeMeasurements: 'Programmagegevens',
    manageRoles: 'Rollen',
    rolePermissions: 'Rolrechten',
    globalRoles: 'Globale rollen',
    globalPermissions: 'Globale rechten',
    tenantRoles: 'Tenantrollen',
    tenantPermissions: 'Tenantrechten',
    dataProviders: 'Gegevensbronnen',
    adminDataProviders: 'Alle FHIR-servers',
    adminDocumentTypes: 'Documenttypen',
    savedDocuments: 'Mijn Documenten',
    pinSidebar: 'Zijbalk vastzetten',
    unpinSidebar: 'Zijbalk losmaken',
    ViewDocument: 'Document Bekijken',
    agent: 'Agents',
  },
  // Authentication
  devLogin: {
    subtitle: 'Lokale ontwikkeling — authenticatie overgeslagen',
    roles: {
      globalAdmin: 'Globale beheerder',
      tenantAdmin: 'Tenantbeheerder',
      coach: 'Coach',
      member: 'Lid',
      remoteMember: 'Lid op afstand',
    },
  },
  brand: {
    loading: 'Laden',
  },
  auth: {
    platformName: 'Mijn Leefstijl Platform',
    poweredBy: 'mogelijk gemaakt door Stichting Je Leefstijl Als Medicijn',
    platformLogin: 'Platform Login',
    password: 'Wachtwoord',
    signIn: 'Inloggen',
    signUp: 'Account aanmaken',
    forgotPassword: 'Wachtwoord vergeten?',
    requestAccess: 'Toegang aanvragen',
    demoMode: 'Demo Modus - Gebruik willekeurige inloggegevens',
    demoDescription: 'Toegang tot uw complete leefstijl wellness dashboard',
    loginSuccess: 'Inloggen succesvol! Doorverwijzen...',
    sessionExpired: {
      title: 'Uw sessie is verlopen',
      message: 'Om uw gegevens te beschermen bent u automatisch afgemeld. Meld u opnieuw aan om verder te gaan.',
      signIn: 'Opnieuw aanmelden',
      dismiss: 'Later',
    },
  },
  // Dashboard
  dashboard: {
    refreshData: 'Gegevens verversen',
    lastSynced: 'Laatst gesynchroniseerd {{time}}',
    justSynced: 'Zojuist gesynchroniseerd',
    signInRequired: 'U moet ingelogd zijn om het dashboard te bekijken.',
    unableToLoad: 'Kan dashboardgegevens niet laden.',
    waitingForProvider_one: 'Je metingen worden opgehaald bij {{providers}}.',
    waitingForProvider_other: 'Je metingen worden opgehaald bij {{providers}}.',
    providerDidNotAnswer_one:
      '{{providers}} gaf geen antwoord, dus wat daar staat ontbreekt op deze pagina. Wat hier is opgeslagen zie je wel, en dat klopt.',
    providerDidNotAnswer_other:
      'Deze bronnen gaven geen antwoord: {{providers}}. Wat daar staat ontbreekt op deze pagina. Wat hier is opgeslagen zie je wel, en dat klopt.',
    activeProgrammes: 'Actieve Programma\'s',
    programmes: 'Programma\'s',
    trackedMeasurements: 'Gevolgde metingen',
    targetsConfigured: 'Geconfigureerde doelen',
    dateAxisLabel: 'Datum',
    measurementTrends: 'Metingtrends',
    measurementTrendsSubtitle: 'Gestapelde weergave om alle metingen samen te verkennen.',
    timeRange: 'Tijdsbereik:',
    oneYear: '1 jaar',
    days: '{{count}}d',
    noMeasurementData: 'Nog geen metinggegevens',
    noMeasurementDataSubtitle: 'Wanneer nieuwe datapunten arriveren, wordt de tijdlijn automatisch bijgewerkt.',
    programmeTargets: 'Programma doelen',
    programmeTargetsSubtitle: 'Doelen worden ingesteld door uw programmabeheerder en hier ter referentie weergegeven.',
    noProgrammeMeasurements: 'Nog geen programmametingen beschikbaar.',
    latestValue: 'Laatste waarde',
    targetRange: 'Doelbereik',
    noMeasurementRecorded: 'Nog geen meting geregistreerd',
    viewMode: 'Weergave',
    viewSimple: 'Eenvoudig',
    viewDetailed: 'Uitgebreid',
    lastMeasured: 'Laatst gemeten {{date}}',
    onTarget: 'Op doel',
    needsAttention: 'Vraagt aandacht',
    noTargetSet: 'Geen doel ingesteld',
    min: 'Min: {{value}} {{unit}}',
    max: 'Max: {{value}} {{unit}}',
    rangeTarget: '{{min}} - {{max}} {{unit}}',
    firstDashboardName: 'Algemeen',
    doneArranging: 'Klaar',
    greetingMorning: 'Goedemorgen{{name}}',
    greetingAfternoon: 'Goedemiddag{{name}}',
    greetingEvening: 'Goedenavond{{name}}',
    updatedAt: 'Bijgewerkt om {{time}}',
    editLayout: 'Indeling aanpassen',
    kindProgramme: 'Programma',
    kindPersonal: 'Persoonlijk',
    goalsInRange: '{{ok}} van {{total}} doelen in bereik',
    noGoalsToCount: 'Nog geen doel met een meting',
    copyTitle: 'Uw eigen versie maken',
    copyBody: 'Dit dashboard komt van uw programma en verandert mee met het programma. Geef uw eigen versie een naam; die kunt u daarna zelf indelen.',
    copyName: 'Naam',
    copyCreate: 'Maken',
    copyNameTaken: 'U heeft al een dashboard met deze naam. Kies een andere.',
    copyFailed: 'Uw eigen versie kon niet worden gemaakt.',
    dashboardsLabel: 'Dashboards',
    switchDashboard: '{{name}}: wissel van dashboard',
    chooseDashboard: 'Kies dashboard',
    goalInRange: 'In bereik',
    goalOffTarget: 'Buiten doel',
    goalNone: 'Geen doel',
    goalNoData: 'Geen data',
    sinceStart: '{{change}} sinds start',
    goalBetween: 'Doel {{minimum}}–{{maximum}}',
    goalAtMost: 'Doel ≤ {{value}}',
    goalAtLeast: 'Doel ≥ {{value}}',
    measuredOn: 'Gemeten op {{date}}',
    noReadingIn: 'Nog geen meting in {{unit}}',
    noReading: 'Nog geen meting',
    addReading: '+ Meting toevoegen',
    arrangeHint: 'Elke kaart laat nu zien waar hij over gaat, hoe breed en hoe hoog hij is, en heeft een prullenbak om hem weg te halen. Sleep een kaart aan het greepje of trek aan de rechteronderhoek om te vergroten. Nieuwe blokken voegt u toe via de galerij hierboven. Uw indeling wordt bewaard zodra u op Klaar drukt.',
    saveFailed: 'Uw indeling kon niet worden bewaard.',
    arrangementRepaired:
      'Uw indeling kon niet worden bewaard, daarom staat het dashboard weer op de basisindeling.',
    deleteFailed: 'Dat dashboard kon niet worden verwijderd.',
    dragWidget: 'Verplaats dit blok: sleep het, of gebruik de pijltoetsen',
    widgetWidth: 'Breedte',
    widgetHeight: 'Hoogte',
    removeWidget: 'Haal dit blok van het dashboard',
    unknownMeasurement: 'Onbekende meting',
    widgetActiveProgrammes: 'Programma\'s',
    widgetTrackedMeasurements: 'Metingen',
    widgetTargetsConfigured: 'Doelen',
    widgetSummary: 'Laatste waarde',
    widgetTrend: 'Gedetailleerd verloop',
    widgetSparkline: 'Eenvoudig verloop',
    widgetMini: 'Mini-verloop',
    widgetRange: 'Streefbereik',
    widgetRecentTrends: 'Recente veranderingen',
    aboutActiveProgrammes: 'Aan hoeveel programma\'s u meedoet.',
    aboutTrackedMeasurements: 'Hoeveel metingen er voor u worden gevolgd.',
    aboutTargetsConfigured: 'Voor hoeveel van die metingen uw programma een bereik heeft ingesteld.',
    aboutRecentTrends: 'Hoeveel één meting is veranderd over vier periodes, met waar u toen stond ten opzichte van het bereik.',
    aboutSummary: 'De meest recente waarde van één meting, en wanneer die is gedaan.',
    aboutRange: 'Waar de laatste waarde ligt ten opzichte van het bereik van uw programma.',
    aboutSparkline: 'Het verloop van één meting in de tijd, zonder assen.',
    aboutMini: 'De laatste waarde boven het verloop ernaartoe, in het kleinste blok.',
    aboutTrend: 'Alle metingen, met eronder een strook om de periode te kiezen.',
    galleryTitle: 'Blokken toevoegen',
    galleryHint: 'Kies een blok om het onderaan uw dashboard te zetten. Welke meting het toont, hoe breed en hoe hoog stelt u in op het blok zelf.',
    galleryAlreadyAdded: 'Staat al op dit dashboard',
    galleryNoMeasurements: 'Nog geen metingen',
    changeTotal: 'Totaal',
    changeYear: 'Jaar',
    changeMonth: 'Maand',
    changePrevious: 'Vorige',
    changeTotalAbout: 'Sinds de eerste vastgelegde meting',
    changeYearAbout: 'Ten opzichte van de meest recente meting van minstens een jaar oud',
    changeMonthAbout: 'Ten opzichte van de meest recente meting van minstens een maand oud',
    changePreviousAbout: 'Ten opzichte van de meting vóór de laatste',
    changeUp: 'omhoog met',
    changeDown: 'omlaag met',
    widthFull: 'Volle breedte',
    widthHalf: 'Twee naast elkaar',
    widthThird: 'Drie naast elkaar',
    widthQuarter: 'Vier naast elkaar',
    heightShort: 'Laag',
    heightMedium: 'Middel',
    heightTall: 'Hoog',
    heightCustom: 'Eigen maat ({{rows}})',
    bandFrom: 'vanaf',
    bandUpTo: 'tot en met',
    bandProgramme: 'doel van het programma',
    settingsTitle: 'Dashboard instellen',
    settingsClose: 'Sluiten',
    dashboardName: 'Naam',
    opensByDefault: 'Opent standaard',
    defaultExplainer: 'Klik op een naam om dat dashboard te tonen. Het dashboard dat u aanvinkt, opent standaard.',
    saveSettings: 'Opslaan',
    yourDashboards: 'Uw dashboards',
    deleteDashboard: 'Verwijder dit dashboard',
    deleteConfirmTitle: '{{name}} verwijderen?',
    deleteConfirmBody:
      'Het dashboard verdwijnt, en de indeling erop verdwijnt mee. Dit kan niet ongedaan worden gemaakt.',
    deleteConfirmCancel: 'Annuleren',
    deleteConfirmDelete: 'Verwijderen',
    newDashboard: 'Nieuw dashboard',
    addDashboard: 'Toevoegen',
    measurementColumn: 'Meting',
    scopeStrip: 'Sleep om te kiezen welke periode de grafiek toont',
    standing: {
      inside: 'Binnen het bereik waarnaar gestreefd wordt',
      above: 'Boven het bereik waarnaar gestreefd wordt',
      below: 'Onder het bereik waarnaar gestreefd wordt',
    },
    scopeFrom: 'Toon metingen vanaf',
    scopeTo: 'Toon metingen tot en met',
    saved: 'Uw indeling is bewaard.',
    settingsSaved: '{{name}} is bewaard.',
    deleted: '{{name}} is verwijderd.',
  },
  profile: {
    welcomeNewUser: 'Welkom! Vul uw profiel in',
    newUserMessage: 'Help ons uw ervaring te personaliseren door uw gegevens hieronder in te vullen.',
    continueToDashboard: 'Doorgaan naar Dashboard',
    myProfile: 'Mijn Profiel',
    reviewDetails: 'Bekijk en werk uw persoonlijke gegevens bij',
    completeProfile: 'Vul uw profiel in',
    keepUpdated: 'Houd uw informatie up-to-date voor betere gepersonaliseerde inzichten',
    accountInformation: 'Accountinformatie',
    referenceCode: 'Referentiecode',
    anonymousSharingId: 'Uw anonieme deel-ID',
    activeSince: 'Actief sinds',
    personalDetails: 'Persoonlijke Gegevens',
    firstName: 'Voornaam',
    lastName: 'Achternaam',
    nickname: 'Bijnaam',
    nicknamePlaceholder: 'Hoe wilt u aangesproken worden?',
    birthDate: 'Geboortedatum',
    gender: 'Geslacht',
    genderMale: 'Man',
    genderFemale: 'Vrouw',
    genderPrefernottosay: 'Zeg ik liever niet',
    emailAddress: 'E-mailadres',
    emailPlaceholder: 'uw.email@voorbeeld.nl',
    emailHelper: 'E-mailadres voor updates en notificaties',
    aboutMe: 'Over Mij',
    headline: 'Kop',
    headlinePlaceholder: 'Een korte slogan over uzelf',
    bio: 'Bio',
    bioPlaceholder: 'Vertel ons een beetje over uzelf',
    motivation: 'Motivatie',
    motivationPlaceholder: 'Wat motiveert u om dit platform te gebruiken?',
    privacyDataSharing: 'Privacy & Gegevensdeling',
    sharingPreference: 'Deelvoorkeur',
    sharingHelper: 'Kies hoe u uw gegevens op dit platform wilt delen',
    shareAnonymously: 'Deel mijn gegevens anoniem',
    shareWithName: 'Deel mijn gegevens met mijn naam',
    doNotShare: 'Deel mijn gegevens niet',
    notificationPreferences: 'Notificatievoorkeuren',
    pushNotifications: 'Push-notificaties',
    pushNotificationsDesc: 'Ontvang push-notificaties op uw apparaat',
    emailNotifications: 'E-mailnotificaties',
    emailNotificationsDesc: 'Ontvang notificaties via e-mail',
    inAppNotifications: 'In-app notificaties',
    inAppNotificationsDesc: 'Ontvang notificaties binnen de applicatie',
    programmeNotifications: 'Programmanotificaties',
    programmeNotificationsHelper: 'Kies per programma hoeveel minuten van tevoren je herinnerd wilt worden aan een geplande meting. Zet Notificaties voor een programma uit om de herinneringen ervoor volledig te stoppen.',
    reminderTime: 'Herinneringstijd',
    reminderTimeCustomLabel: 'Minuten (1-180)',
    reminderNoScheduledMeasurements: 'Dit programma heeft nog geen geplande metingen.',
    notificationsLabel: 'Notificaties',
    reminderLoadFailed: 'Herinneringsinstellingen laden mislukt',
    saving: 'Opslaan...',
    saveProfile: 'Profiel Opslaan',
    saveSuccess: 'Profiel succesvol opgeslagen',
    errorLoading: 'Kon profiel niet laden',
    errorSaving: 'Kon profiel niet opslaan',
    deleteAccount: 'Account verwijderen',
    deleteAccountTitle: 'Account verwijderen?',
    deleteAccountWarning: 'Weet u zeker dat u al uw gegevens wilt verwijderen? Heeft u alles geëxporteerd wat u wilt bewaren? U kunt het daarna niet meer terughalen, want deze actie is onomkeerbaar.',
    no: 'Nee',
    yes: 'Ja',
    confirmDeletionTitle: 'Verwijderen van account bevestigen',
    confirmDeletionInstructionPrefix: 'Weet u zeker dat u al uw gegevens uit het systeem wilt wissen? Typ dan',
    confirmDeletionInstructionSuffix: 'in het tekstvak en bevestig',
    typeToConfirmPlaceholder: 'Typ hier DELETE MY ACCOUNT',
    cancel: 'Annuleren',
    deleting: 'Verwijderen...',
    confirmDeletion: 'Verwijderen bevestigen',
  },
  uploadPDF: {
    typesFailed: 'De documenttypen konden niet worden gelezen.',
    title: 'Document Uploaden',
    description: 'Hier kunt u uw PDF-bestanden uploaden.',
    documentType: 'Documenttype',
    selectDocumentType: 'Selecteer documenttype',
    labTest: 'Labtest',
    insuranceDocument: 'Verzekeringsdocument',
    idCard: 'Identiteitskaart',
    enabledAIExtraction: 'Ingeschakeld: we extraheren observaties na het uploaden.',
    disabledAIExtraction: 'Uitgeschakeld: we slaan alleen het document op.',
    descriptionTitle: 'Beschrijving',
    descriptionLabel: 'Beschrijving',
    descriptionPlaceholder: 'bijv. Bloedtest van huisartsenbezoek (24/01/2026)',
    filenameTitle: 'Bestandsnaam',
    filenameLabel: 'Bestandsnaam',
    filenamePlaceholder: 'Voer een bestandsnaam in',
    filenameRequired: 'Voer een bestandsnaam in.',
    aiExtractionTitle: 'AI-extractie',
    aiExtractionSelectTypeHelper: 'Selecteer een documenttype om AI-extractie-opties te zien.',
    dropFilesPrompt: 'Sleep bestanden hierheen, of selecteer vanaf uw apparaat',
    chooseFiles: 'Bestand(en) kiezen',
    deleteDocument: 'Selectie wissen',
    filesSelected: 'bestand geselecteerd',
    uploadButton: 'Uploaden',
    documentSuccessfullyUploaded: 'Document succesvol geüpload.',
    aiExtractionNotAvailable: 'AI-extractie is niet beschikbaar voor dit documenttype',
    selectDocumentTypeAlert: 'Selecteer een documenttype voordat u uploadt.',
    selectFileAlert: 'Selecteer een bestand voordat u uploadt.',
    uploadFailed: 'Kon het document niet uploaden. Probeer het opnieuw.',
    uploadError: 'Er is een fout opgetreden bij het uploaden van het document. Probeer het opnieuw.',
    selectDocumentFileAlert: 'Selecteer een bestand om te uploaden.',
    downloadError: 'Downloaden van document mislukt',
  },
  documentTypes: {
    title: 'Documenttypen',
    subtitle: 'De typen waaruit mensen kiezen als ze een document toevoegen. Een type dat documenten gebruiken wordt gedeactiveerd, niet verwijderd.',
    add: 'Documenttype toevoegen',
    columnName: 'Naam',
    columnCode: 'Code',
    columnExtraction: 'AI-uitlezing aangeboden',
    columnDescription: 'Beschrijving',
    yes: 'Ja',
    no: 'Nee',
    edit: 'Documenttype wijzigen',
    remove: 'Documenttype verwijderen',
    deactivate: 'Deactiveren',
    activate: 'Activeren',
    actionFailed: 'Dat is niet gelukt: {{detail}}',
    messages: {
      added: '{{name}} is toegevoegd.',
      updated: '{{name}} is opgeslagen.',
      removed: '{{name}} is verwijderd.',
      removedDeactivated: '{{name}} wordt door documenten gebruikt, dus het is gedeactiveerd in plaats van verwijderd.',
      activated: '{{name}} is weer actief.',
      deactivated: '{{name}} is gedeactiveerd.',
    },
    dialog: {
      titleAdd: 'Een documenttype toevoegen',
      titleEdit: 'Documenttype wijzigen',
      code: 'Code',
      codeHelp: 'Hoofdletters, cijfers en underscores, maximaal 20 tekens. Na het opslaan kan de code niet meer veranderen.',
      codeLocked: 'De code kan niet worden gewijzigd.',
      codeRequired: 'Vul een code in.',
      codeFormat: 'Gebruik alleen hoofdletters, cijfers en underscores.',
      codeTaken: 'Een ander documenttype heeft deze code.',
      name: 'Naam',
      nameRequired: 'Vul een naam in.',
      nameTaken: 'Een ander documenttype heeft deze naam.',
      description: 'Beschrijving',
      extractionRequired: 'AI-uitlezing aanbieden',
      extractionRequiredHelp: 'Als iemand een document van dit type toevoegt, wordt AI-uitlezing aangeboden en aangevinkt. Het vinkje kan uit.',
      active: 'Actief',
      activeHelp: 'Een inactief type wordt niet aangeboden als iemand een document toevoegt. Documenten die het type hebben, houden het.',
      saveFailed: 'Het documenttype kon niet worden opgeslagen.',
    },
    removeDialog: {
      title: 'Dit documenttype verwijderen?',
      messageDeletes: '{{name}} wordt verwijderd. Geen enkel document heeft dit type.',
      messageDeactivates: '{{name}} wordt door documenten gebruikt, dus het wordt in plaats daarvan gedeactiveerd: mensen kunnen het niet meer kiezen en hun documenten houden het. Je kunt het weer activeren.',
      remove: 'Verwijderen',
    },
  },
  documentPage: {
    document: 'Document',
    extractions: 'Uitlezingen',
    loadFailedTitle: 'Dit document kon niet worden gelezen',
    loadFailed: 'Probeer het zo meteen opnieuw.',
    notFoundTitle: 'Dit document is niet gevonden',
    notFoundBody: 'Het is mogelijk verwijderd, of het is niet van jou.',
    noExtractionTitle: 'Er is niets uitgelezen',
    noExtractionBody: 'Dit document is zonder AI-uitlezing toegevoegd, dus er is niets uit gelezen.',
    extractionNothingYetBody: 'De uitlezing heeft nog niets om te laten zien.',
    extractionFailedBody: 'De uitlezing is mislukt, dus er is niets uit dit document gelezen.',
    extractionLoadFailedTitle: 'De uitlezingen konden niet worden gelezen',
    extractionLoadFailed: 'Probeer het zo meteen opnieuw.',
    referenceRange: 'Referentiewaarde',
    measuredAt: 'Gemeten op {{date}}',
  },
  savedDocuments: {
    edit: 'Document wijzigen',
    fileNameRequired: 'Vul een bestandsnaam in.',
    messages: {
      removed: '{{name}} is verwijderd.',
    },
    removeDialog: {
      title: 'Dit document verwijderen?',
      message: '{{name}} en het bestand worden verwijderd. Dit kan niet ongedaan worden gemaakt.',
    },
    fileName: 'Bestandsnaam',
    fileType: 'Bestandstype',
    uploadedBy: 'Geupload door',
    description: 'Beschrijving',
    uploadDate: 'Uploaddatum',
    status: 'Status',
    inProgress: 'In behandeling',
    readyForReview: 'Klaar voor beoordeling',
    committed: 'Vastgelegd',
    inReview: 'In beoordeling',
    uploaded: 'Geüpload',
    failed: 'Mislukt',
    unknownStatus: 'Mislukt',
    noStatus: 'Geen status',
    noDocuments: 'Geen documenten gevonden',
    yourDocuments: 'Uw documenten',
    viewPreviouslyUploaded: 'Bekijk eerder geüploade documenten',
    documents: 'Documenten',
    filter: 'Filteren',
    allTypes: 'Alle',
    preview: 'Voorbeeld',
    uploadNewDocument: 'Een nieuw document uploaden',
    delete: 'Verwijderen',
    review: 'Beoordelen',
    updateDocument: 'Document bijwerken',
    update: 'Bijwerken',
    cancel: 'Annuleren',
    save: 'Opslaan',
    documentSuccessfullyDeleted: 'Document succesvol verwijderd',
    deleteError: 'Fout bij het verwijderen van document',
    deleteErrorPartial_one: '{{count}} document kon niet worden verwijderd',
    deleteErrorPartial_other: '{{count}} documenten konden niet worden verwijderd',
    downloadError: 'Downloaden van document mislukt',
    deleteConfirm: 'Weet u zeker dat u {{count}} document(en) wilt verwijderen?',
    deleting: 'Bezig met verwijderen...',
    close: 'Sluiten',
    download: 'Downloaden',
    types: {
      bloodTestReport: 'Bloedonderzoeksrapport',
      stoolTestReport: 'Ontlastingsonderzoeksrapport',
      consultationNote: 'Consultatienotitie',
    },
    updateSuccess: 'Document bijgewerkt',
    updateError: 'Het document kon niet worden bijgewerkt',
  },
  documentExtractionReview: {
    aiChip: 'TRPI aangedreven door AI',
    title: 'Extractiebeoordeling',
    previewTitle: 'Documentvoorbeeld',
    preview: {
      loadingDocument: 'Document wordt geladen...',
      preparingPdf: 'PDF voorbereiden...',
      zoom: 'Zoom {{percent}}%',
      zoomControlsAria: 'Zoom bediening',
      zoomOut: 'Uitzoomen',
      fit: 'Aanpassen',
      zoomIn: 'Inzoomen',
      fullscreen: 'Volledig scherm',
      exitFullscreen: 'Volledig scherm verlaten',
      unavailable: 'Voorvertoning in de app is niet beschikbaar voor dit bestand. Download dit bestand om het te bekijken.',
      pageOf: 'Pagina {{current}} van {{total}}',
      prevPageAria: 'Vorige pagina',
      nextPageAria: 'Volgende pagina',
    },
    subtitle: 'Controleer de geëxtraheerde waarden voordat je ze vastlegt in je kernobservaties.',
    committedInfo: 'Dit document kan niet verder worden bewerkt, maar je kunt de geëxtraheerde waarden nog wel bekijken.',
    commit: {
      action: 'Vastleggen in kern',
      committed: 'Vastgelegd',
      aria: 'Geëxtraheerde metingen vastleggen',
      success: 'Document vastgelegd',
      error: 'Document vastleggen mislukt',
    },
    tooltips: {
      download: 'Downloaden',
      fullscreen: 'Volledig scherm',
      exitFullscreen: 'Volledig scherm verlaten',
    },
    aria: {
      download: 'Document downloaden',
      fullscreen: 'Volledig scherm voor rechterpaneel wisselen',
    },
    updatedAt: 'Bijgewerkt op: {{date}}',
    failedMessage: 'Extractie mislukt. Je kunt het document nog steeds bekijken. Neem contact op met support als het probleem aanhoudt.',
    loadDataError: 'Fout bij het laden van de geëxtraheerde gegevens. Probeer het opnieuw.',
    extractionInProgress: 'Extractie is in behandeling.',
    notExtracted: 'Niet geëxtraheerd',
    timeline: {
      button: 'Tijdlijn bekijken',
      title: 'Extractietijdlijn',
    },
    loading: 'Extractie laden...',
    providers: {
      organisation: 'organisatie',
      practitioner: 'behandelaar',
      searchPlaceholder: 'Zoek bestaande {{type}}',
      notInList: 'Staat niet in de lijst',
    },
    sections: {
      measurements: {
        title: 'Geëxtraheerde metingen',
        columns: {
          measurementName: 'Geëxtraheerde meting',
          valueExtracted: 'Geëxtraheerde waarde',
          unitExtracted: 'Eenheid (geëxtraheerd)',
          ucumCode: 'UCUM-code',
          ucumName: 'UCUM-naam',
          loincCode: 'LOINC-code',
          loincName: 'LOINC-naam',
          referenceRangeMin: 'Ref min',
          referenceRangeMax: 'Ref max',
        },
        actions: {
          resetColumns: 'Kolomweergave resetten',
          edit: 'Metingen bewerken',
          save: 'Metingen opslaan',
          cancel: 'Wijzigingen aan metingen annuleren',
          deleteRow: 'Rij verwijderen',
          deleteRowDisabled: 'Schakel bewerken in om rijen te verwijderen',
          addRow: 'Rij toevoegen',
        },
        aria: {
          resetColumns: 'Kolomweergave resetten',
          edit: 'Geëxtraheerde metingen bewerken',
          save: 'Geëxtraheerde metingen opslaan',
          cancel: 'Wijzigingen aan geëxtraheerde metingen annuleren',
          deleteRow: 'Rij {{id}} verwijderen',
        },
        toasts: {
          addSuccess: 'Meetrij toegevoegd',
          addError: 'Meetrij toevoegen mislukt',
          deleteSuccess: 'Meting verwijderd',
          deleteError: 'Meting verwijderen mislukt',
        },
      },
      organisation: {
        title: 'Uitvoerende organisatie',
        status: {
          matchFound: 'Organisatie gevonden',
          noMatch: 'Geen organisatie gevonden',
        },
        tooltips: {
          validation: 'Vul de juiste waarden in',
          save: 'Organisatiedetails opslaan',
          cancel: 'Organisatiewijzigingen annuleren',
        },
        aria: {
          edit: 'Uitvoerende organisatie bewerken',
          save: 'Wijzigingen van uitvoerende organisatie opslaan',
          cancel: 'Geëxtraheerde organisatiewijzigingen annuleren',
        },
        fields: {
          name: 'Naam',
          address: 'Adres',
          houseNumber: 'Huisnummer',
          city: 'Plaats',
          postalCode: 'Postcode',
          countryCode: 'Landcode',
          contactPerson: 'Contactpersoon',
          phoneNumber: 'Telefoonnummer',
          emailAddress: 'E-mailadres',
        },
      },
      practitioner: {
        title: 'Aanvragend behandelaar',
        status: {
          matchFound: 'Behandelaar gevonden',
          noMatch: 'Geen behandelaar gevonden',
        },
        tooltips: {
          validation: 'Vul de juiste waarden in',
          save: 'Behandelaargegevens opslaan',
          cancel: 'Behandelaaraanpassingen annuleren',
        },
        aria: {
          edit: 'Aanvragend behandelaar bewerken',
          save: 'Wijzigingen van aanvragend behandelaar opslaan',
          cancel: 'Geëxtraheerde behandelaarwijzigingen annuleren',
        },
        fields: {
          name: 'Naam',
          role: 'Rol',
          phoneNumber: 'Telefoonnummer',
          emailAddress: 'E-mailadres',
        },
      },
    },
    sectionSaved: 'Uw wijzigingen zijn opgeslagen.',
    sectionSaveFailed: 'Uw wijzigingen konden niet worden opgeslagen.',
  },
  // Master Data Management
  masterData: {
    tabs: {
      measurements: 'Metingen',
      units: 'Eenheden',
    },
    required: 'Verplicht',
    remove: 'Verwijderen',
    measurementList: {
      title: 'Metingen',
      subtitle: 'Elke code die het platform kent: de LOINC-uitgave en de eigen codes. Open een code voor de assen en eenheden.',
      add: 'Meting toevoegen',
      edit: 'Meting bewerken',
      remove: 'Meting verwijderen',
      columns: {
        name: 'Naam',
        code: 'Code',
        dataType: 'Soort waarde',
        loincCode: 'LOINC-code',
        description: 'Omschrijving',
      },
      removeDialog: {
        title: 'Deze meting verwijderen?',
        message: '{{name}} verdwijnt voor elke organisatie. Een meting die nog eenheden heeft, in een programma zit of waarvoor waarden zijn vastgelegd, wordt niet verwijderd.',
      },
    },
    measurementDialog: {
      addTitle: 'Een meting toevoegen',
      editTitle: '{{name}} bewerken',
      name: 'Naam',
      code: 'Code',
      codeHelp: 'Hoe koppelingen en programma\'s hem kennen, zoals WEIGHT. Geen twee metingen hebben dezelfde.',
      dataType: 'Soort waarde',
      loincCode: 'LOINC-code',
      loincHelp: 'Optioneel. Een code uit de LOINC-versie die het platform heeft, zoals 29463-7.',
      description: 'Omschrijving',
    },
    dataTypes: {
      number: 'Getal',
      text: 'Tekst',
      boolean: 'Ja of nee',
      date: 'Datum',
    },
    dimensionWords: {
      length: 'lengte',
      mass: 'massa',
      time: 'tijd',
      amountOfSubstance: 'hoeveelheid stof',
      electricCurrent: 'elektrische stroom',
      temperature: 'temperatuur',
      luminousIntensity: 'lichtsterkte',
      dimensionless: 'dimensieloos',
      per: 'per',
    },
    unitList: {
      title: 'Eenheden',
      subtitle: 'De eenheden waarin waarden worden vastgelegd, voor elke organisatie, met hun dimensie. Welke metingen er een gebruiken stel je in op elke meting.',
      add: 'Eenheid toevoegen',
      edit: 'Eenheid bewerken',
      remove: 'Eenheid verwijderen',
      columns: {
        name: 'Naam',
        dimension: 'Dimensie',
        ucumCode: 'UCUM-code',
        quantityKinds: 'Grootheden',
      },
      removeDialog: {
        title: 'Deze eenheid verwijderen?',
        message: '{{name}} verdwijnt voor elke organisatie. Een eenheid die bij een meting hoort, of waarin waarden zijn vastgelegd, wordt niet verwijderd.',
      },
      noUcum: 'Geen UCUM-code',
      noDimension: 'Geen dimensie',
    },
    unitDialog: {
      addTitle: 'Een eenheid toevoegen',
      editTitle: '{{name}} bewerken',
      name: 'Naam',
      dimension: 'Dimensie',
      dimensionHelp: 'Bij een eenheid zonder UCUM-code vul je de dimensie hier in. Eenheden met één dimensie kunnen in elkaar worden omgerekend.',
      noDimension: 'Geen dimensie',
      ucumCode: 'UCUM-code',
      ucumHelp: 'Een code uit de UCUM-uitgave van het platform, zoals kg. Geen twee eenheden delen er een.',
      noUcum: 'Deze eenheid heeft geen UCUM-code. Vul er een in als die er is, zoals kg.',
      workedOut: 'Afgeleid uit de UCUM-code.',
      workedOutAfterSave: 'Wordt afgeleid zodra je opslaat.',
      quantityKinds: 'Grootheden die het kan uitdrukken',
      quantityKindsHelp: 'Een eenheid past bij een meting als ze de grootheid van die meting mag uitdrukken. Uit QUDT, of hier gekozen.',
      dimensionsFailed: 'De dimensies konden niet worden gelezen, dus je kunt er geen kiezen.',
      dimensionsRetry: 'Opnieuw proberen',
    },
    measurementPage: {
      units: 'Eenheden',
      notFoundTitle: 'Deze meting is niet gevonden',
      notFoundBody: 'Misschien is hij verwijderd, of klopt het adres niet.',
      loadFailedTitle: 'Deze meting kon niet worden gelezen',
      loadFailed: 'Probeer het zo meteen opnieuw.',
    },
    measurementUnits: {
      add: 'Eenheid koppelen',
      edit: 'Koppeling wijzigen',
      remove: 'Koppeling verwijderen',
      isDefault: 'Canoniek',
      columns: {
        unit: 'Eenheid',
        multiplier: 'Vermenigvuldiger',
        offset: 'Verschuiving',
        isDefault: 'Canoniek',
        precision: 'Decimalen',
        conversion: 'Omrekening naar de canonieke eenheid',
        approvedBy: 'Goedgekeurd door',
        validMinimum: 'Geldig vanaf',
        validMaximum: 'Geldig tot',
      },
      removeDialog: {
        title: 'Deze koppeling verwijderen?',
        message: '{{unit}} wordt in geen enkele organisatie meer aangeboden voor {{measurement}}. Waarden die al zijn vastgelegd, houden wat is opgeslagen.',
      },
      confirm: 'Factor bevestigen',
      confirmedToast: 'Factor voor {{unit}} bevestigd',
      factor: '1 {{from}} = {{multiplier}} {{to}}',
      factorWithOffset: '({{from}} + {{offset}}) × {{multiplier}} = {{to}}',
      viaAlgebra: 'Afgeleid uit de UCUM-codes.',
      viaMolarMass: 'Via de molaire massa van {{analyte}}, {{mass}} g/mol. Bron: {{source}}.',
      formula: '{{factor}}. {{via}}',
      approved: '{{by}}, {{date}}',
      notApproved: 'Nog niet goedgekeurd',
      unavailable: {
        dimensionDiffers: 'Geen factor: deze eenheid heeft een andere dimensie dan de canonieke eenheid.',
        noCanonicalUnit: 'Nog geen factor: de meting heeft geen canonieke eenheid.',
        noMolarMass: 'Nog geen factor: de molaire massa van de analyt staat niet in het register.',
        noDimension: 'Geen factor: deze eenheid heeft geen dimensie.',
      },
      enterMolarMass: 'Molaire massa invullen',
    },
    unitLinkDialog: {
      addTitle: 'Een eenheid toevoegen aan {{measurement}}',
      editTitle: '{{unit}} bij {{measurement}} bewerken',
      unit: 'Eenheid',
      noUnitsLeft: 'Elke eenheid is al een eenheid van deze meting. Voeg er eerst een toe onder Eenheden.',
      noUnits: 'Er zijn nog geen eenheden. Voeg er eerst een toe onder Eenheden.',
      multiplier: 'Vermenigvuldiger',
      multiplierHelp: 'Een waarde in deze eenheid, maal dit getal, is de waarde in de basiseenheid.',
      multiplierWrong: 'Vul een getal in dat geen 0 is, met hoogstens tien cijfers voor en na de komma.',
      offset: 'Verschuiving',
      offsetHelp: 'Wordt opgeteld vóór het vermenigvuldigen: 0 voor de meeste eenheden, -32 voor graden Fahrenheit.',
      numberWrong: 'Vul een getal in met hoogstens tien cijfers voor en na de komma.',
      conversionChanged: 'De waarden van elke organisatie in {{unit}} worden via deze omrekening opgeslagen en getoond, dus een wijziging verandert ze overal.',
      precision: 'Decimalen',
      precisionHelp: 'Optioneel. Met hoeveel decimalen een waarde in deze eenheid wordt getoond.',
      precisionWrong: 'Vul een heel getal in van 0 tot en met {{max}}.',
      isDefault: 'Canonieke eenheid: waarden worden erin getoond en het bereik wordt erin gecontroleerd',
      otherDefault: 'Een andere eenheid is de canonieke. Zet die daar eerst uit.',
      isDefaultHelp: 'De eerste eenheid van een meting is de canonieke eenheid. Er is er één.',
      validMinimum: 'Geldig minimum',
      validMaximum: 'Geldig maximum',
      validHelp: 'Optioneel. De laagste waarde die kan worden vastgelegd, in {{unit}}. Een waarde in een andere eenheid wordt eerst omgerekend.',
      rangeWrong: 'Het minimum is hoger dan het maximum.',
    },
    messages: {
      added: '{{name}} toegevoegd',
      saved: '{{name}} opgeslagen',
      removed: '{{name}} verwijderd',
    },
    measurementCodes: {
      list: {
        columns: {
          name: 'Naam',
          code: 'Code',
          codeSystem: 'Codesysteem',
          status: 'Status',
          inUse: 'In gebruik',
        },
        yes: 'Ja',
        no: 'Nee',
        views: {
          label: 'Toon',
          all: 'Alle codes',
          inUse: 'In gebruik',
        },
        systemFilter: 'Codesysteem',
        systemAll: 'Alle codesystemen',
      },
      general: {
        code: 'Code',
        codeSystem: 'Codesysteem',
        name: 'Naam',
        status: 'Status',
        release: 'Uitgave',
        releaseValue: '{{version}}, geladen op {{date}}',
        releaseNone: 'Niet van toepassing: geen uitgave bevat een eigen code.',
        releaseUnknown: 'Niet vastgelegd voor deze code.',
        valueKind: 'Soort waarde',
        quantityKind: 'Soort grootheid',
      },
      axes: {
        title: 'Wat het meet',
        component: 'Component',
        analyte: 'Analyt',
        property: 'Eigenschap',
        time: 'Tijd',
        system: 'Systeem',
        scale: 'Schaal',
        method: 'Methode',
        noMethod: 'Geen',
        unknown: 'Het platform kent de assen van deze code niet. Ze wordt met niets gegroepeerd.',
      },
      groups: {
        title: 'Gegroepeerd met',
        nothing: 'Op dit niveau met niets gegroepeerd.',
      },
      levels: {
        THIS_CODE: 'Alleen deze code',
        ANY_METHOD: 'Hetzelfde, welke methode ook',
      },
      trace: {
        title: 'Een waarde natrekken',
        help: 'Vul het nummer in dat een lid je geeft voor een waarde. Je ziet hoe die is vastgelegd en waar die vandaan kwam.',
        number: 'Nummer van de waarde',
        show: 'Herkomst tonen',
      },
      dialog: {
        addTitle: 'Een eigen meting toevoegen',
        editTitle: '{{name}} wijzigen',
        name: 'Naam',
        code: 'Code',
        codeHelp: 'Begint met X, zoals X-HAPPY-1. Geen twee metingen delen er een.',
        codeSystem: 'Codesysteem',
        analyteHelp: 'Laat leeg om de component te gebruiken.',
        noPart: 'Geen onderdeel past. Typ een naam om er een toe te voegen.',
        partsFailed: 'De onderdelen konden niet worden gelezen. Typ opnieuw om het nog eens te proberen.',
        addPart: '"{{name}}" als nieuw onderdeel toevoegen',
        partAdded: '{{name}} toegevoegd als onderdeel',
        newPropertyKind: 'Soort grootheid voor een nieuwe eigenschap',
        newPropertyKindHelp: 'Alleen gebruikt als je hierboven een nieuwe eigenschap toevoegt.',
        noKind: 'Geen',
      },
    },
    unitTabs: {
      label: 'Eenheden en molaire massa\'s',
      units: 'Eenhedenlijst',
      molarMasses: 'Molaire massa\'s',
    },
    molarMasses: {
      title: 'Molaire massa\'s',
      subtitle: 'Een massaconcentratie komt via de molaire massa samen met een molaire concentratie van dezelfde analyt. Elke massa heeft een bron.',
      add: 'Molaire massa toevoegen',
      edit: 'Molaire massa wijzigen',
      remove: 'Molaire massa verwijderen',
      addTitle: 'Een molaire massa toevoegen',
      editTitle: 'De molaire massa van {{name}} wijzigen',
      columns: {
        analyte: 'Analyt',
        gramsPerMole: 'Gram per mol',
        source: 'Bron',
      },
      analyte: 'Analyt',
      analyteHelp: 'Zoek op naam of Part-nummer, zoals Glucose.',
      gramsPerMole: 'Gram per mol',
      massHelp: 'Voor glucose: 180,156.',
      massWrong: 'Vul een getal boven 0 in, met maximaal tien cijfers voor en na de punt.',
      source: 'Bron',
      sourceHelp: 'Waar het getal vandaan komt: een LOINC-groep, een ChEBI- of PubChem-nummer, een naslagwerk.',
      removeDialog: {
        title: 'Deze molaire massa verwijderen?',
        message: '{{name}} heeft geen molaire massa meer. Factoren die haar gebruiken kunnen niet meer worden afgeleid.',
      },
    },
  },
  tenantSettings: {
    title: 'Tenant Instellingen',
    subtitle: 'Beheer instellingen',
    loadError: 'Kan tenant-instellingen niet laden. U heeft mogelijk geen toestemming om deze tenant te bekijken.',
    generalInfo: 'Algemene Informatie',
    tenantName: 'Tenant Naam',
    organisation: 'Organisatie',
    organisationHelper: 'Organisatie kan niet worden gewijzigd',
    tenantId: 'Tenant ID',
    yourRole: 'Uw Rol',
    roleDescription: 'Uw rol in deze organisatie is {{role}}.',
    permissionsConfigured: 'Wat deze rol mag, stelt de organisatie zelf in. Een beheerder ziet en wijzigt het op het rollenscherm.',
    saveName: 'Naam opslaan',
    nameSaved: 'De naam van de tenant is bijgewerkt.',
    saveError: 'De naam kon niet worden opgeslagen. Mogelijk mag u die niet wijzigen.',
  },
  communityUsers: {
    title: 'Gemeenschapsgebruikers',
    subtitle: 'Alle gebruikers met een account op het platform. Persoonlijke gegevens worden alleen getoond op basis van de privacyvoorkeuren van elke gebruiker.',
    loadError: 'Kan gemeenschapsgebruikers niet laden. Probeer het opnieuw.',
    view: 'Bekijken',
    noUsersTitle: 'Geen gedeelde gebruikers',
    noUsersNotice: 'Niemand heeft nog gegevens beschikbaar gesteld om te bekijken.',
  },
  adminDashboard: {
    menuItems: {
      questionnaires: 'Vragenlijsten',
      tenants: 'Tenants',
      organisations: 'Organisaties',
      users: 'Systeemgebruikers',
    },
    users: {
      title: 'Systeemgebruikers',
      search: 'Zoek op gebruikersnaam, e-mail, naam of organisatie',
      empty: 'Geen gebruikers gevonden',
      columns: {
        id: 'ID',
        email: 'E-mail',
        name: 'Naam',
        status: 'Status',
        organisations: 'Organisaties',
      },
    },
  },
  organisationDialog: {
    titleCreate: 'Nieuwe Organisatie Aanmaken',
    titleEdit: 'Organisatie bewerken',
    emailInvalid: 'Vul een e-mailadres in, zoals naam@voorbeeld.nl',
    dateInvalid: 'Vul een datum in',
    legalNameRequired: 'Wettelijke naam is verplicht',
    createError: 'Kan organisatie niet aanmaken. Controleer of unieke velden al in gebruik zijn.',
    fields: {
      legalName: 'Wettelijke Naam',
      tradeName: 'Handelsnaam',
      taxId: 'BTW-nummer',
      referenceCode: 'Referentiecode',
      emailAddress: 'E-mailadres',
      phoneNumber: 'Telefoonnummer',
      website: 'Website',
      practiceCode: 'Praktijkcode',
      chamberOfCommerceNumber: 'KVK-nummer',
      subscriptionDate: 'Abonnementsdatum',
      active: 'Actief',
    },
    actions: {
      create: 'Aanmaken',
    },
  },
  organisationList: {
    title: 'Organisaties',
    addButton: 'Organisatie toevoegen',
    updateSuccess: 'Organisatie succesvol bijgewerkt',
    updateError: 'Kan organisatie niet bijwerken',
    columns: {
      legalName: 'Juridische naam',
      tradeName: 'Handelsnaam',
      taxId: 'BTW-nummer',
      referenceCode: 'Referentiecode',
      emailAddress: 'E-mail',
      phoneNumber: 'Telefoon',
      website: 'Website',
      practiceCode: 'Praktijkcode',
      chamberOfCommerceNumber: 'KvK-nummer',
      subscriptionDate: 'Abonnementsdatum',
      status: 'Status',
    },
    statusLabels: {
      active: 'Actief',
      inactive: 'Inactief',
    },
    edit: 'Bewerken',
    deactivate: 'Deactiveren',
    alreadyInactive: 'Al inactief. Zet deze weer actief via Bewerken.',
    deactivateTitle: 'Organisatie deactiveren',
    deactivateMessage: '{{name}} wordt als inactief gemarkeerd. Er wordt niets verwijderd, en via Bewerken zet je deze weer actief.',
    deactivated: 'Organisatie gedeactiveerd',
    created: 'Organisatie aangemaakt',
  },
  questionnaireEditor: {
    questionsCount: 'Vragen ({{count}})',
    addQuestionButton: 'Vraag toevoegen',
    emptyState: {
      message: 'Nog geen vragen. Voeg je eerste vraag toe!',
      button: 'Vraag toevoegen',
    },
    question: {
      prefix: 'Vraag',
      required: 'Verplicht',
      identity: 'Identiteit: ',
      optionsLabel: 'Opties:',
    },
    tooltips: {
      edit: 'Bewerken',
      delete: 'Verwijderen',
    },
    dialog: {
      titleNew: 'Nieuwe vraag',
      titleEdit: 'Vraag bewerken',
      questionType: 'Vraagtype',
      questionPrompt: 'Vraagstelling',
      requiredQuestion: 'Verplichte vraag',
      identityField: 'Dit is een identiteitsveld (voor gebruikersonboarding)',
      identityFieldType: 'Type identiteitsveld',
      listOptionsTitle: 'Lijstopties',
      addOptionButton: 'Optie toevoegen',
      codeLabel: 'Code',
      codePlaceholder: 'bijv., SAT_HOOG',
      valueLabel: 'Weergavewaarde',
      valuePlaceholder: 'bijv., Zeer tevreden',
      emptyOptions: 'Voeg minimaal één optie toe voor dropdown vragen',
      cancel: 'Annuleren',
      save: 'Opslaan',
      create: 'Aanmaken',
      removeOption: 'Optie verwijderen',
    },
    deleteDialog: {
      title: 'Vraag verwijderen',
      message: 'Weet je zeker dat je deze vraag wilt verwijderen? Dit verwijdert ook alle bijbehorende antwoorden.',
      cancel: 'Annuleren',
      delete: 'Verwijderen',
    },
    messages: {
      updateSuccess: 'Vraag succesvol bijgewerkt',
      createSuccess: 'Vraag succesvol aangemaakt',
      deleteSuccess: 'Vraag succesvol verwijderd',
      saveError: 'Kan vraag niet opslaan',
      deleteError: 'Kan vraag niet verwijderen',
    },
    questionTypes: {
      text: 'Tekst',
      number: 'Nummer',
      date: 'Datum',
      list: 'Lijst/Dropdown',
      boolean: 'Ja/Nee',
    },
    identityTypes: {
      first_name: 'Voornaam',
      last_name: 'Achternaam',
      email: 'E-mail',
      date_of_birth: 'Geboortedatum',
    },
  },
  questionnaireList: {
    title: 'Vragenlijsten',
    newButton: 'Vragenlijst toevoegen',
    table: {
      name: 'Naam',
      description: 'Beschrijving',
      status: 'Status',
      version: 'Versie',
      publicLink: 'Openbare link',
    },
    statusLabels: {
      active: 'Actief',
      inactive: 'Inactief',
    },
    dialog: {
      titleNew: 'Vragenlijst toevoegen',
      titleEdit: 'Vragenlijst bewerken',
      name: 'Naam',
      description: 'Beschrijving',
      active: 'Actief',
      create: 'Aanmaken',
      nameRequired: 'Vul een naam in',
      publicLink: 'Openbare link',
      noPublicLink: 'Deze vragenlijst heeft nog geen openbare link.',
      newLink: 'Maak bij opslaan een nieuwe link. De huidige link werkt dan niet meer.',
      makeLink: 'Maak bij opslaan een openbare link',
    },
    deleteDialog: {
      title: 'Vragenlijst verwijderen',
      message: '{{name}} en de vragen worden verwijderd. Een vragenlijst die mensen hebben ingevuld wordt niet verwijderd; zet die op inactief.',
      delete: 'Verwijderen',
    },
    messages: {
      updateSuccess: 'Vragenlijst succesvol bijgewerkt',
      createSuccess: 'Vragenlijst succesvol aangemaakt',
      deleteSuccess: 'Vragenlijst verwijderd',
      saveError: 'Kan vragenlijst niet opslaan',
      linkCopied: 'Link gekopieerd naar klembord',
      copyFailed: 'De link kon niet worden gekopieerd',
    },
    copyLink: 'Link kopiëren',
    copyLinkOf: 'Kopieer de openbare link van {{name}}',
    noLink: 'Geen',
    edit: 'Bewerken',
    delete: 'Verwijderen',
    noOrganisationTitle: 'Nog geen organisatie',
    noOrganisationNotice: 'Vragenlijsten horen bij een organisatie, en dit account hoort bij geen enkele.',
  },
  submissionViewer: {
    table: {
      id: 'ID',
      status: 'Status',
      email: 'E-mail',
      name: 'Naam',
      submittedAt: 'Ingediend op',
    },
    statusLabels: {
      submitted: 'Ingediend',
      draft: 'Concept',
      scored: 'Beoordeeld',
      abandoned: 'Afgebroken',
    },
    dialog: {
      title: 'Inzending - Antwoorden',
      submissionDetails: 'Inzendingsdetails',
      status: 'Status',
      submittedAt: 'Ingediend op',
      notYetSubmitted: 'Nog niet ingediend',
      email: 'E-mail',
      name: 'Naam',
      answersCount: 'Antwoorden ({{count}})',
      noAnswers: 'Nog geen antwoorden ingediend.',
      questionPrefix: 'Vraag {{number}}',
      close: 'Sluiten',
      unknownQuestion: 'Een vraag die niet meer in deze vragenlijst staat',
    },
    booleanValues: {
      yes: 'Ja',
      no: 'Nee',
    },
    answersFailed: 'De antwoorden konden niet worden geladen',
    openAnswers: 'Antwoorden verstuurd op {{sent}}',
  },
  tenantList: {
    title: 'Tenants',
    addButton: 'Tenant Toevoegen',
    saveError: 'Kan tenant niet opslaan',
    noOrganisationsWarning: 'Geen organisaties beschikbaar. Maak eerst een organisatie aan voordat u tenants toevoegt.',
    table: {
      id: 'ID',
      name: 'Naam',
      organisation: 'Organisatie',
    },
    tooltips: {
      edit: 'Bewerken',
    },
    dialog: {
      titleCreate: 'Tenant Aanmaken',
      titleEdit: 'Tenant Bewerken',
      tenantName: 'Tenant Naam',
      organisation: 'Organisatie',
      create: 'Aanmaken',
      nameRequired: 'Vul een naam in',
      organisationRequired: 'Kies een organisatie',
      organisationLocked: 'Een tenant blijft bij zijn organisatie',
    },
    messages: {
      created: 'Tenant toegevoegd',
      updated: 'Tenant opgeslagen',
    },
  },
  publicQuestionnairePage: {
    loading: 'Laden...',
    invalidLink: 'Ongeldige vragenlijst link',
    notFound: 'Vragenlijst niet gevonden of niet langer actief',
    checkLink: 'Controleer de link en probeer het opnieuw.',
    thankYou: 'Dank u!',
    submitted: 'Uw antwoorden zijn succesvol ingediend.',
    newAccountCreated: 'Er is een nieuw account voor u aangemaakt. Controleer uw e-mail voor inloggegevens.',
    progress: 'Voortgang',
    questions: 'vragen',
    required: 'Dit veld is verplicht',
    identityFieldInfo: 'Deze informatie wordt gebruikt om uw account aan te maken',
    submitButton: 'Vragenlijst Indienen',
    submitting: 'Bezig met indienen...',
    autoSave: 'Uw antwoorden worden automatisch opgeslagen terwijl u typt',
    missingRequired: 'Beantwoord alle verplichte vragen (nog {{count}} open)',
    submitError: 'Indienen van vragenlijst mislukt. Probeer het opnieuw.',
    placeholders: {
      text: 'Voer uw antwoord in...',
      number: 'Voer een nummer in...',
      email: 'Voer uw e-mail in',
      firstName: 'Voer uw voornaam in',
      lastName: 'Voer uw achternaam in',
      dateOfBirth: 'Voer uw geboortedatum in',
    },
    booleanValues: {
      yes: 'Ja',
      no: 'Nee',
    },
    answerSaveFailed: 'Uw antwoord kon niet worden opgeslagen. Probeer het opnieuw.',
  },
  manageProgrammeMeasurements: {
    title: 'Programmametingen',
    tenant: 'Tenant',
    addButton: 'Programmameting Toevoegen',
    noProgrammes: 'Geen programma\'s beschikbaar. Maak eerst een programma aan.',
    noOrganisationTitle:
      'Nog geen organisatie',
    noOrganisation: 'Programmametingen horen bij een organisatie, en dit account hoort bij geen enkele.',
    rolesUnknownTitle: 'Jouw rollen niet gelezen',
    rolesUnknownNotice:
      'Zonder die rollen weet dit scherm niet welke organisatie het moet tonen; dat is iets anders dan bij geen enkele horen.',
    table: {
      programmeName: 'Programmanaam',
      measurementName: 'Metingnaam',
      loincCode: 'LOINC-code',
      minimumTarget: 'Minimumdoel',
      maximumTarget: 'Maximumdoel',
      defaultUnit: 'Standaardeenheid',
      reminder: 'Herinnering',
      everyWeeks: 'Elke {{count}} weken: {{days}}',
    },
    actions: {
      edit: 'Bewerken',
      delete: 'Verwijderen',
    },
    dialog: {
      titleAdd: 'Programmameting Toevoegen',
      titleEdit: 'Programmameting Bewerken',
      programme: 'Programma',
      measurement: 'Meting',
      minimumTarget: 'Minimumdoel',
      maximumTarget: 'Maximumdoel',
      defaultUnit: 'Standaardeenheid',
      selectProgramme: 'Selecteer een programma',
      selectMeasurement: 'Selecteer een meting',
      measurementSearchHint: 'Typ minstens drie letters van de naam of de code.',
      measurementNoMatch: 'Geen meting past.',
      measurementSearchFailed: 'De metingen konden niet worden gelezen. Typ opnieuw om het nog eens te proberen.',
      selectUnit: 'Selecteer een eenheid',
      repeatEvery: 'Herhaal elke',
      weeks: 'weken',
      repeatOn: 'Herhaal op',
      ends: 'Eindigt',
      endsProgrammeEnd: 'Wanneer het programma eindigt',
      endsOn: 'Op',
      endsAfter: 'Na',
      occurrences: 'keren',
      timeOfDay: 'Om',
      timeOfDayOptional: 'optioneel',
      selectWeekdaysFirstWarning: 'Selecteer eerst een dag',
      recurrenceHint: 'Selecteer geen dagen om geen schema vast te leggen. Weken worden geteld vanaf de week waarin het programma start.',
      programmeHasNoEndDate: 'Dit programma heeft geen einddatum en wordt dus onbeperkt herhaald',
      save: 'Opslaan',
      update: 'Bijwerken',
    },
    deleteConfirm: 'Weet u zeker dat u meting "{{measurementName}}" uit programma "{{programmeName}}" wilt verwijderen?',
    deleteTitle: 'Deze meting uit het programma halen?',
    messages: {
      loadRolesFailed: 'Laden van tenant rollen mislukt',
      loadDataFailed: 'Laden van gegevens mislukt',
      partlyRead: 'Van sommige programma’s konden de metingen niet worden gelezen, dus deze lijst is misschien niet compleet.',
      noTenantSelected: 'Geen tenant geselecteerd',
      selectProgrammeError: 'Selecteer een programma',
      selectMeasurementError: 'Selecteer een meting',
      selectUnitError: 'Selecteer een standaardeenheid',
      recurrenceIntervalError: 'Herhaal elke moet een heel aantal weken tussen 1 en 52 zijn',
      recurrenceEndDateError: 'Kies een einddatum die niet voor de start van het programma ligt',
      recurrenceOccurrencesError: 'Het aantal keren moet een heel getal tussen 1 en 520 zijn',
      deleteSuccess: 'Programmameting succesvol verwijderd',
      addSuccess: 'Programmameting succesvol toegevoegd',
      addFailed: 'Toevoegen van programmameting mislukt',
      updateSuccess: 'Programmameting succesvol bijgewerkt',
      updateFailed: 'Bijwerken van programmameting mislukt',
      notAllowed: 'Je mag dit niet wijzigen.',
    },
  },
  manageProgrammeDialog: {
    titleCreate: 'Nieuw Programma Aanmaken',
    titleEdit: 'Programma Bewerken',
    programmeName: 'Programmanaam',
    programmeNameRequired: 'Programmanaam is verplicht',
    description: 'Beschrijving',
    targetAudience: 'Doelgroep',
    label: 'Label',
    labelHelp: 'Een kort label dat leden bij het programma zien, zoals Pilot.',
    startDate: 'Startdatum',
    startDateRequired: 'Startdatum is verplicht',
    startDateLocked: 'De startdatum kan na aanmaken niet meer worden gewijzigd',
    endDate: 'Einddatum',
    endDateHelper: 'Laat leeg voor doorlopende programma\'s',
    endDateError: 'Einddatum moet na startdatum zijn',
    startDatePast: 'Startdatum kan niet in het verleden liggen',
    endDatePast: 'Einddatum kan niet in het verleden liggen',
    saveChanges: 'Wijzigingen Opslaan',
    createProgramme: 'Programma Aanmaken',
    saveFailed: 'Opslaan van programma mislukt',
    banner: {
      label: 'Banner',
      choose: 'Kies een afbeelding',
      remove: 'Banner verwijderen',
      none: 'Nog geen banner. Leden zien de naam van het programma op de kleur van de tenant.',
      accepted: 'PNG, WebP of JPEG, hooguit 2 MB, tussen 800 × 200 en 6000 × 6000 pixels.',
      refused: 'Dit bestand kan niet worden gebruikt. Kies een PNG-, WebP- of JPEG-afbeelding van hooguit 2 MB, tussen 800 × 200 en 6000 × 6000 pixels.',
      saveFailed: 'De banner kon niet worden opgeslagen. Probeer het opnieuw.',
    },
  },
  manageProgrammes: {
    title: 'Programma\'s',
    addButton: 'Programma Toevoegen',
    tenant: 'Tenant',
    loadRolesFailed: 'Laden van tenant rollen mislukt',
    loadProgrammesFailed: 'Laden van programma\'s mislukt',
    table: {
      programmeName: 'Programmanaam',
      description: 'Beschrijving',
      target: 'Doel',
      label: 'Label',
      startDate: 'Startdatum',
      endDate: 'Einddatum',
    },
    actions: {
      edit: 'Bewerken',
      delete: 'Verwijderen',
    },
    deleteDialog: {
      title: 'Programma Verwijderen',
      message: 'Weet u zeker dat u het programma "{{programmeName}}" wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
      delete: 'Verwijderen',
    },
    messages: {
      createSuccess: 'Programma succesvol aangemaakt',
      updateSuccess: 'Programma succesvol bijgewerkt',
      deleteSuccess: 'Programma succesvol verwijderd',
    },
    ongoing: 'Doorlopend',
    loadFailedTitle: 'Programma’s niet gelezen',
    noOrganisationNotice: 'Programma’s horen bij een organisatie, en dit account hoort bij geen enkele.',
    noOrganisationTitle: 'Nog geen organisatie',
    rolesUnknownNotice: 'Zonder die rollen weet dit scherm niet wat je beheert; dat is iets anders dan niets beheren.',
    rolesUnknownTitle: 'Jouw rollen niet gelezen',
  },
  programmesOverview: {
    title: 'Beschikbare Programma\'s',
    subtitle: 'Zoek een programma dat bij je past en doe met één klik mee.',
    loadFailed: 'Laden van programma\'s mislukt',
    enrollFailed: 'Inschrijven voor programma mislukt',
    enroll: 'Inschrijven',
    leave: 'Programma verlaten',
    unenrollFailed: 'Uitschrijven voor programma mislukt',
    close: 'Sluiten',
    retry: 'Opnieuw proberen',
    filters: {
      label: 'Tonen',
      all: 'Alle',
      open: 'Om aan mee te doen',
      enrolled: 'Ingeschreven',
    },
    search: {
      label: 'Programma’s zoeken',
      clear: 'Zoekopdracht wissen',
    },
    noMatch: {
      title: 'Geen programma gevonden',
      body: 'Wis de zoekopdracht of kies Alle.',
      clear: 'Zoekopdracht en filter wissen',
    },
    status: {
      enrolled: 'Ingeschreven',
      notEnrolled: 'Niet ingeschreven',
    },
    phase: {
      starts: 'Start {{date}}',
      week: 'Week {{week}} van {{total}}',
      since: 'Loopt sinds {{date}}',
      ended: 'Afgelopen op {{date}}',
    },
    card: {
      enrolled: '{{formatted}} ingeschreven',
    },
    dialog: {
      aim: 'Doel',
      runs: 'Looptijd',
      rhythm: 'Hoe vaak je meet',
      enrolledYou: 'Je bent ingeschreven',
      ended: 'Dit programma is afgelopen.',
      rhythmFailed: 'Hoe vaak je meet kon niet worden gelezen.',
      enrolledPeople_one: '{{formatted}} persoon ingeschreven',
      enrolledPeople_other: '{{formatted}} mensen ingeschreven',
      runsFrom: 'Vanaf {{start}}, geen einddatum',
      runsFromTo_one: '{{start}} tot {{end}} · {{count}} week',
      runsFromTo_other: '{{start}} tot {{end}} · {{count}} weken',
    },
    rhythm: {
      daily: 'Meet elke dag',
      oncePerWeek: 'Meet één keer per week',
      timesPerWeek: 'Meet {{count}} keer per week',
      everyWeeks: 'Meet elke {{count}} weken',
      weekdaysOn: 'Je meet op {{days}}',
    },
    noProgrammesNotice: 'Jouw organisatie heeft nog geen programma’s opengezet om aan mee te doen.',
    noProgrammesTitle: 'Nog geen programma’s',
    programmesUnknownNotice: 'De lijst is niet aangekomen; dat is iets anders dan geen programma’s hebben.',
    programmesUnknownTitle: 'Programma’s niet gelezen',
    confirmUnenroll: {
      title: 'Dit programma verlaten?',
      body: 'Je wordt uitgeschreven voor {{programme}}. Je kunt je later opnieuw inschrijven.',
      cancel: 'Annuleren',
      confirm: 'Uitschrijven',
    },
    noTenantTitle: 'Nog niet bij een organisatie',
    noTenantNotice: 'Een beheerder van je organisatie voegt je toe. Daarna zie je hier de programma’s.',
  },
  chat: {
    page_title: 'Chatten met AI',
    page_desc: 'Krijg leefstijladvies van onze AI.',
    hero_title: 'Welkom terug{{name}}',
    prompt_desc: 'Waarmee kan ik u vandaag helpen?',
    menu_title: 'Chat',
    action_button_diets: 'Voeding',
    action_button_energy: 'Energie',
    action_button_nutritions: 'Voedingsstoffen',
  },
  observations: {
    title: 'Mijn metingen invoeren',
    subtitle: 'Voer uw gezondheidsmetingen in en bekijk ze',
    viewToggleLabel: 'Weergave',
    viewCalendar: 'Kalender',
    viewStack: 'Stapel',
    viewTimeline: 'Tijdlijn',
    refresh: 'Verversen',
    noMeasurements: 'Geen metingen beschikbaar. Schrijf u eerst in voor een programma.',
    addObservation: 'Meting toevoegen',
    submitting: 'Bezig met indienen...',
    searchBy: 'Zoeken op',
    searchValue: 'Zoekwaarde',
    columns: 'Kolommen',
    columnsLabel: 'Weergegeven Kolommen Wijzigen',
    eventType: 'Gebeurtenistype',
    dateTime: 'Datum tijd',
    measurementType: 'Metingstype',
    value: 'Waarde',
    sourceDocument: 'Bron document',
    sourceDocumentDescription: 'Documentbeschrijving',
    actions: 'Acties',
    loading: 'Uw metingen worden geladen…',
    filter: {
      title: 'Filter',
      label: 'Programma\'s',
      all: 'Alle programma\'s',
      notInProgramme: 'Niet in een programma',
    },
    units: {
      systemOption: 'Systeem ({{unit}})',
      defaultOption: '{{unit}} (standaard)',
    },
    source: {
      column: 'Opslag',
      local: 'Dit platform',
      remoteLive: 'Aanbieder',
      remoteCached: 'Kopie',
      storedAtProvider: 'Naar {{provider}}',
      storedAtProviderHelp:
        'Wat u hier invult, wordt opgeslagen bij {{provider}}. Dit platform bewaart er geen eigen kopie van.',
      remoteEventType: 'Gegeven van aanbieder',
      tooltipLocal: 'Dit platform bewaart deze meting.',
      tooltipProvider: 'Opgehaald bij {{provider}}',
      tooltipFetchedAt: 'gelezen op {{fetchedAt}}',
      deleteUnavailable:
        'Deze meting staat bij een aanbieder en kan hier niet worden verwijderd. ' +
        'Beëindig de verbinding in je profielinstellingen.',
      viewSources: 'Bronnen bekijken',
      dialogTitle: 'Waar deze metingen vandaan komen',
      unnamed: 'Naamloze bron',
      entriesStoredHere:
        'Een meting die je hier toevoegt, wordt door dit platform bewaard.',
      managePermissions: 'Gegevenstoestemmingen openen',
      measurementsRead: 'Gelezen metingen: {{measurements}}',
      codesRequested: 'Gevraagd om {{codes}}, en er kwam deze keer niets terug.',
      nothingRequested:
        'Er staan geen metingen aan voor deze bron, dus er is niets ' +
        'opgevraagd.',
      notContactedDetail:
        'Aan deze bron is voor dit overzicht niets gevraagd: haar metingen ' +
        'worden hier al bewaard en staan dus in de lijst hierboven.',
      summary: {
        connected:
          'Deze metingen worden gelezen uit {{count}} verbonden bron(nen), ' +
          'naast de metingen die hier bewaard worden.',
        someUnavailable:
          'Een verbonden bron kon niet worden bereikt, dus een deel van je ' +
          'dossier staat nu niet in deze lijst. Er is niets verloren.',
        someStale:
          'Sommige metingen komen uit een bewaarde kopie die verouderd kan ' +
          'zijn.',
        nothingEnabled:
          'Er staan geen metingen aan voor je verbonden bron(nen), dus er is ' +
          'niets bij ze opgehaald.',
      },
      state: {
        reading: 'Gelezen',
        stale: 'Kopie kan verouderd zijn',
        nothingEnabled: 'Niets aangezet',
        unavailable: 'Niet bereikbaar',
        notContacted: 'Deze keer niet gelezen',
      },
    },
    eventTypes: {
      manualInput: 'Handmatige Invoer',
      deviceSync: 'Apparaat Synchronisatie',
      uploaded: 'Geüpload',
      coachingSession: 'Coachingssessie',
    },
    validation: {
      eventTypeRequired: 'Gebeurtenistype is verplicht',
      dateTimeRequired: 'Datum en tijd zijn verplicht',
      invalidDateTime: 'Ongeldige datum en tijd',
      atLeastOneMeasurement: 'Voer minimaal één meetwaarde in',
      invalidValue: 'Ongeldige waarde',
      validationFailed: 'Validatie mislukt',
      fixErrors: 'Corrigeer alle validatiefouten voordat u indient',
    },
    messages: {
      noChanges: 'Geen wijzigingen om op te slaan',
      storedAtProviders: 'Opgeslagen bij {{providers}}.',
      successSingle: 'Observatie succesvol opgeslagen',
      successMultiple: 'Alle observatie-invoer succesvol ingediend!',
      submitError: 'Fout bij indienen van observaties',
      updateError: 'Fout bij bijwerken van observatie',
      deleteSuccess: 'Observatie succesvol verwijderd',
      removeSuccess: 'Observatie verwijderd',
      deleteError: 'Fout bij verwijderen van observatie',
      loadError: 'Fout bij laden van observaties',
      networkError: 'Netwerkfout opgetreden',
      saveError: 'Fout bij opslaan van wijzigingen',
    },
    dialog: {
      deleteTitle: 'Observatie Verwijderen',
      deleteMessage: 'Weet u zeker dat u deze observatiegebeurtenis wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
      cancel: 'Annuleren',
      delete: 'Verwijderen',
    },
    dayView: {
      previousDay: 'Vorige dag',
      nextDay: 'Volgende dag',
      today: 'Vandaag',
      noEntries: 'Geen observaties geregistreerd op deze dag',
      edit: 'Bewerken',
      save: 'Opslaan',
      dataTypeNumber: 'Getal',
      dataTypeText: 'Tekst',
      dataTypeBoolean: 'Ja/nee',
      noProgramme: 'Geen programma',
      noValues: 'Geen waarden vastgelegd',
      newMeasurementTitle: 'Nieuwe Meting',
      previewPending: 'Nog niet opgeslagen',
      programme: 'Programma',
      selectProgramme: 'Selecteer een programma',
      measurement: 'Meting',
      selectMeasurement: 'Selecteer een meting',
      noMeasurementSelected: 'Selecteer eerst een meting voordat je een waarde invoert',
      noProgrammeSelected: 'Selecteer eerst een programma voordat je een meting selecteert',
      value: 'Waarde',
      viewLabel: 'Weergave',
      viewDay: 'Dag',
      viewWeek: 'Week',
      viewMonth: 'Maand',
      previousWeek: 'Vorige week',
      nextWeek: 'Volgende week',
      previousMonth: 'Vorige maand',
      nextMonth: 'Volgende maand',
      noEntriesRange: 'Geen observaties geregistreerd in deze periode',
      legendTitle: 'Programma\'s',
      legendScheduledLabel: 'Geplande meting',
      legendNotInProgramme: 'Niet in een programma',
      dueLabel: 'Te doen',
      doneLabel: 'Gedaan',
      dueTooltip: '{{measurement}} — {{programme}}',
      recordDue: '{{measurement}} vastleggen',
      slotHint: 'Klik op een leeg tijdvak in de agenda om iets nieuws vast te leggen',
      moreEvents: '+{{count}} meer',
    },
  },
  // Settings
  settings: {
    title: 'Taal- en regio-instellingen',
    language: 'Taal',
    region: 'Regio',
    systemOfMeasurement: 'Meetsysteem',
    timezone: 'Tijdzone',
    metricSystem: 'Metriek Systeem',
    imperialSystem: 'Imperiaal Systeem',
    usCustomaryUnits: 'Verenigde Staten Gebruikelijke Eenheden',
    regionInfoTitle: 'Regio Informatie',
    regionInfoText: 'Kies uw regio om getallen, datums en tijden in lokale formaten weer te geven (bijv. VS: 1,234.56, 03/07/2025, 5:30 PM; Duitsland: 1.234,56, 07.03.2025, 17:30).',
    regionInfo: 'Kies uw regio om getallen, datums en tijden in lokale formaten weer te geven.',
    selectLanguage: 'Selecteer Taal',
    selectRegion: 'Selecteer Regio',
    selectMeasurement: 'Selecteer Meetsysteem',
    selectTimezone: 'Selecteer Tijdzone',
    preview: 'Voorbeeld',
    formatExamples: 'Formaat Voorbeelden',
    save: 'Opslaan',
    cancel: 'Annuleren',
    saving: 'Opslaan...',
    savedSuccessfully: 'Instellingen succesvol opgeslagen!',
    saveSuccess: 'Instellingen succesvol opgeslagen!',
    warningTitle: 'Wijzigingen Bevestigen',
    warningMessage: 'Deze wijzigingen treden onmiddellijk in werking. Taalwijzigingen zullen de interface direct bijwerken, terwijl regionale en meetinstellingen van toepassing zijn op alle weergegeven gegevens.',
    confirmSave: 'Wijzigingen Opslaan',
    languageLabel: 'Taal',
    regionLabel: 'Regio',
    measurementLabel: 'Meting',
    numberLabel: 'Nummer',
    dateLabel: 'Datum',
    timeLabel: 'Tijd',
    weightLabel: 'Gewicht',
    heightLabel: 'Lengte',
    distanceLabel: 'Afstand',
    temperatureLabel: 'Temperatuur',
    saveFailed: 'Uw instellingen konden niet worden opgeslagen.',
    languageSaveFailed: 'Uw taalkeuze kon niet worden opgeslagen.',
  },
  // Common actions
  actions: {
    add: 'Toevoegen',
    view: 'Bekijken',
    edit: 'Bewerken',
    delete: 'Verwijderen',
    save: 'Opslaan',
    cancel: 'Annuleren',
    close: 'Sluiten',
    open: 'Openen',
  },
  dataProviders: {
    addServer: 'FHIR-server toevoegen',
    authConnected: 'Gekoppeld met {{name}}.',
    authFailed: 'De autorisatie is niet afgerond: {{detail}}',
    columnAddress: 'Adres',
    columnPlatformStatus: 'Platformstatus',
    columnServerStatus: 'Serverstatus',
    columnName: 'Naam',
    columnOwner: 'Eigenaar van de server',
    columnVisibility: 'Wie hem kan zien',
    connectionEnded: 'Je hebt deze koppeling beeindigd. Opnieuw koppelen begint een nieuwe.',
    empty: 'Nog geen FHIR-servers geregistreerd',
    loadFailedTitle: 'Je gegevensbronnen konden niet gelezen worden',
    loadFailedBody: 'Dat is iets anders dan dat er niets geregistreerd staat. Probeer het opnieuw; blijft het misgaan, dan kan het platform zijn eigen lijst niet bereiken.',
    loadFailedRetry: 'Opnieuw proberen',
    ownServerFailed: 'Die server kon niet worden toegevoegd.',
    ownerAMember: 'Een lid',
    ownerColumnJustMe: 'Alleen ik',
    ownerGroup: 'Groep {{name}}',
    ownerHelp: 'Dit bepaalt wie de server kan wijzigen. Wie hem ziet, stel je daarna in op zijn pagina.',
    ownerJustMe: 'Ik ben de eigenaar',
    ownerOrganisation: 'Organisatie {{name}}',
    ownerQuestion: 'Van wie is deze server?',
    ownerSearchPlaceholder: 'Zoek jezelf of een organisatie',
    ownerUnknown: 'Een andere partij',
    providerRemoved: '{{name}} is verwijderd',
    registerSubtitle: 'Elke server op het platform, van welke partij dan ook.',
    registerTitle: 'Alle FHIR-servers',
    removeProvider: 'Server verwijderen',
    subtitle: 'Servers waar je metingen staan. Open een bron om te koppelen en te kiezen wat dit platform mag lezen en terugschrijven.',
    title: 'FHIR-servers',
    visibleEveryone: 'Iedereen op het platform',
    visibleOwnerOnly: 'Niemand behalve de eigenaar',
    visibleMembersOf: 'Leden van {{tenants}}',
    visibleNoTenant: 'Aan geen tenant aangeboden',
    tenantOfOrganisation: '{{tenant}} ({{organisation}})',
    connection: {
      'not-connected': 'Niet gekoppeld',
      'connected': 'Gekoppeld',
      'connected-untried': 'Gekoppeld, nog niet gebruikt',
      'not-answering': 'Antwoordt niet',
      'ended': 'Beeindigd',
    },
  },
  dataProviderList: {
    active: 'Actief',
    inactive: 'Inactief',
    paused: 'Gepauzeerd',
    pausedSince: 'Gepauzeerd sinds {{when}}',
    deactivate: 'Deactiveren',
    activate: 'Activeren',
    pause: 'Pauzeren',
    resume: 'Hervatten',
    actionFailed: 'Dat is niet gelukt. {{detail}}',
    edit: 'Server bewerken',
    remove: 'Server verwijderen',
    dialog: {
      titleAdd: 'Een FHIR-server toevoegen',
      titleEdit: 'FHIR-server bewerken',
      required: 'Dit is verplicht',
      ownersFailed: 'Voor wie een server kan zijn, kon niet worden gelezen, dus er kan nu geen worden toegevoegd. Sluit dit en probeer het opnieuw.',
      ownersLoading: 'Voor wie een server kan zijn, wordt nog gelezen. Sla zo meteen opnieuw op.',
      noOwners: 'Er is geen persoon of organisatie waarvoor een server kan zijn, dus er kan geen worden toegevoegd.',
      addressLocked: 'Een adres kan niet worden gewijzigd: een server op een ander adres is een nieuwe registratie.',
      ownerLocked: 'De eigenaar kan niet worden gewijzigd: die bepaalt wie de server kan wijzigen en verwijderen.',
      active: 'Actief',
      activeHelp: 'Een inactieve server wordt aan niemand aangeboden en neemt geen nieuwe koppelingen aan.',
      saveFailed: 'De server kon niet worden opgeslagen.',
    },
    pauseDialog: {
      title: 'Deze server pauzeren?',
      message: 'Er wordt niets gelezen van of geschreven naar {{name}} tot je hervat. Wie gekoppeld is, ziet dat de server gepauzeerd is. Coachtoegang wordt daar intussen niet bijgewerkt.',
      pause: 'Pauzeren',
    },
    removeDialog: {
      title: 'Deze server verwijderen?',
      messageDeletes: 'Niemand gebruikt {{name}}, dus de server wordt verwijderd. Dit kun je niet ongedaan maken.',
      messageDeactivates: '{{name}} is in gebruik, dus de server wordt inactief in plaats van verwijderd. Zolang hij inactief is, kan niemand koppelen. Wie nu gekoppeld is, houdt die koppeling tot die zelf wordt beëindigd.',
      remove: 'Verwijderen',
    },
    messages: {
      added: '{{name}} is toegevoegd',
      updated: '{{name}} is opgeslagen',
      deactivated: '{{name}} is inactief',
      activated: '{{name}} is weer actief',
      paused: '{{name}} is gepauzeerd',
      resumed: '{{name}} draait weer',
      removedDeactivated: '{{name}} is in gebruik en is daarom inactief gemaakt in plaats van verwijderd',
    },
  },
  dataSourcePage: {
    loadFailedTitle: 'Deze bron kon niet worden gelezen',
    loadFailed: 'Probeer het zo opnieuw.',
    notFoundTitle: 'Deze bron is niet gevonden',
    notFoundBody: 'Hij is misschien verwijderd, of hij wordt jou niet aangeboden.',
    lastRead: 'Laatst opgehaald {{when}}',
    neverRead: 'Nog niet opgehaald',
    aboutTitle: 'Over deze server',
    connectTitle: 'Koppel deze bron',
    connectBody: 'Je meldt je aan bij {{name}}. Die laat dit platform weten welk dossier van jou is. Je typt niets in.',
    connect: 'Koppelen',
    connectRow: 'Koppelen',
    connectWhenConnected: 'Je bent gekoppeld. Open de bron om de koppeling te wijzigen of te beëindigen.',
    connectCannotNameRecord: '{{name}} is hier ingesteld zonder aanmelding, dus dit platform weet niet welk dossier van jou is.',
    connectNotSetUp: 'Aanmelden bij {{name}} is nog niet ingesteld.',
    cannotConnectTitle: 'Deze bron kun je hier niet koppelen',
    cannotConnectBody: '{{name}} is hier ingesteld zonder aanmelding. Alleen de eigen aanmelding van een bron vertelt dit platform welk dossier van jou is. Daarom kun je deze bron niet koppelen.',
    inactiveBody: '{{name}} neemt op dit moment geen nieuwe koppelingen aan.',
    inactiveConnected: '{{name}} neemt geen nieuwe koppelingen aan. Je kunt je eigen koppeling blijven gebruiken of beëindigen.',
    pausedBody: '{{name}} is gepauzeerd. Er wordt niets van gelezen of naartoe geschreven tot de server hervat wordt.',
    pausedConnect: '{{name}} is gepauzeerd, dus je kunt nu niet koppelen.',
    stateTips: {
      active: 'Deze server neemt nieuwe koppelingen aan, en wat je toestaat wordt gewoon gelezen en teruggeschreven.',
      inactive: 'Deze server neemt geen nieuwe koppelingen aan. Een koppeling die je al hebt, blijft tot je die beëindigt.',
      paused: 'Er wordt voorlopig niets van deze server gelezen of naar deze server geschreven. Wordt hier een kopie bewaard, dan zie je die nog.',
    },
    serverStatus: {
      reachable: 'Bereikbaar',
      unreachable: 'Onbereikbaar',
      unread: 'Nog niet gelezen',
      notLinked: 'Niet gekoppeld',
    },
    serverStatusTips: {
      reachable: 'Bij je laatste uitlezing of test gaf deze server antwoord.',
      unreachable: 'Bij je laatste uitlezing of test gaf deze server geen antwoord. Open de bron om hem opnieuw te testen.',
      unread: 'Je bent gekoppeld, maar er is nog niets van deze server gelezen.',
      notLinked: 'Je bent niet aan deze server gekoppeld, dus of hij antwoordt is niet bekend.',
    },
    connectionTitle: 'Jouw koppeling',
    connectedSince: 'Gekoppeld op',
    recordHere: 'Je dossier bij deze bron',
    keepCopy: 'Kopie bewaren op dit platform',
    keepCopyOn: 'Aan. Je metingen blijven hier ook beschikbaar als de bron offline is.',
    keepCopyOff: 'Uit. Metingen worden alleen opgehaald terwijl je ernaar kijkt.',
    copyOnToast: 'Dit platform bewaart nu een kopie van {{name}}.',
    copyOffToast: 'Er wordt geen kopie van {{name}} meer bewaard. De kopie hier is verwijderd.',
    undo: 'Ongedaan maken',
    undone: 'Ongedaan gemaakt.',
    nothingToChange: 'Er was niets te veranderen.',
    permissionsTitle: 'Wat dit platform met deze bron mag',
    summaryNone: 'Dit platform leest nu niets uit deze bron.',
    summary: 'Leest {{reading}} van {{total}} metingen, schrijft er {{writing}} terug.',
    summaryNoWrite: 'Leest {{reading}} van {{total}} metingen, schrijft niets terug.',
    readEverything: 'Alles lezen',
    writeNothing: 'Niets terugschrijven',
    columnWriteBack: 'Terugschrijven',
    readToggle: '{{name}} lezen',
    writeToggle: '{{name}} terugschrijven',
    writeNeedsRead: 'Terugschrijven kan pas als lezen aan staat.',
    permissionsFootnote: 'Terugschrijven kan alleen voor metingen die het platform ook mag lezen. Wijzigingen gelden meteen.',
    state: {
      'read-write': 'Lezen en terugschrijven',
      read: 'Alleen lezen',
      write: 'Alleen terugschrijven',
      none: 'Geen toegang',
    },
    readOnToast: 'Dit platform leest nu {{name}} uit {{source}}.',
    readOffToast: 'Dit platform leest {{name}} niet meer uit {{source}}.',
    writeOnToast: '{{name}} wordt nu ook teruggeschreven naar {{source}}.',
    writeOffToast: '{{name}} wordt niet meer teruggeschreven naar {{source}}.',
    allReadToast: 'Dit platform leest nu alle metingen die het mag uit {{source}}.',
    noWriteToast: 'Er wordt niets meer teruggeschreven naar {{source}}.',
    viewsLabel: 'Welke bronnen',
    views: {
      all: 'Alle',
      connected: 'Gekoppeld',
      'not-connected': 'Niet gekoppeld',
    },
    columnSource: 'Bron',
    columnAccess: 'Toegang',
    accessLabel: 'Leest {{reading}} en schrijft {{writing}} van {{total}} metingen terug',
    legendRead: 'Platform mag lezen',
    legendWrite: 'Platform mag terugschrijven',
  },
  dataProviderOffers: {
    table: {
      tenant: 'Tenant',
      organisation: 'Organisatie',
      offeredAt: 'Aangeboden op',
    },
    withdraw: 'Intrekken',
    locked: '{{name}} is gedeeld met het hele platform, dus elk lid ziet hem. Dit aanbod blijft bewaard, maar ligt vast tot delen uit staat bij Algemeen.',
    lockedReason: 'Ligt vast zolang de server met het hele platform gedeeld is',
    offered: '{{name}} is aangeboden aan {{tenants}}',
    withdrawn: '{{name}} wordt niet meer aangeboden aan {{tenant}}',
    withdrawDialog: {
      title: 'Aanbod intrekken',
      message: 'Leden van {{tenant}} zien {{name}} dan niet meer. Wie al gekoppeld is, blijft gekoppeld.',
    },
    add: {
      button: 'Aanbieden aan een tenant',
      title: '{{name}} aanbieden',
      save: 'Aanbieden',
      organisation: 'Organisatie',
      organisationRequired: 'Kies een organisatie',
      noOrganisation: 'Geen organisatie gevonden',
      tenant: 'Tenant',
      tenantRequired: 'Kies een tenant',
      allTenants: 'Alle tenants van {{organisation}}',
      tenantCount_one: '{{count}} tenant',
      tenantCount_other: '{{count}} tenants',
      everyTenant: 'Deze server wordt al aan elke tenant aangeboden.',
      readFailed: 'De tenants konden niet gelezen worden.',
      failed: 'Aanbieden is niet gelukt.',
    },
  },
  dataProviderPage: {
    offers: 'Aangeboden aan',
    sharing: {
      title: 'Gedeeld met het hele platform',
      on: 'Aan: elk lid van het platform ziet deze server. Zijn aanbod aan tenants blijft bewaard, en ligt vast zolang dit aan staat.',
      offOffered: 'Uit: alleen leden van de tenants waaraan hij wordt aangeboden, zien hem.',
      personal: 'Een server van een persoon is alleen van die persoon en wordt niet met het hele platform gedeeld. Registreer hem onder een organisatie om hem te delen.',
      sharedOn: '{{name}} is gedeeld met het hele platform',
      sharedOff: '{{name}} is niet meer gedeeld met het hele platform',
      failed: 'De wijziging is niet opgeslagen.',
    },
    status: 'Status',
    fhirVersion: 'FHIR-versie',
    canRead: 'Kan worden gelezen',
    canWrite: 'Kan naar worden geschreven',
    checkedAt: 'Laatst gecontroleerd',
    notChecked: 'Nog niet gecontroleerd',
    yes: 'Ja',
    no: 'Nee',
    authOauth: 'OAuth 2.0: het lid meldt zich aan bij de aanbieder',
    authServiceAccount: 'Een serviceaccount van dit platform',
    oauthConfigured: 'OAuth ingesteld',
    oauthScopes: 'Scopes die het vraagt',
    smartScopes: 'Scopes die de server biedt',
    recordClaim: 'Claim die het dossier noemt',
    recordSystem: 'Identificatiesysteem van het dossier',
    notFoundTitle: 'Deze server is niet gevonden',
    notFoundBody: 'Hij is misschien verwijderd, of het adres klopt niet.',
    loadFailedTitle: 'Deze server kon niet worden gelezen',
    loadFailed: 'Probeer het zo nog eens.',
  },

  dataPermissions: {
    platformSection: 'Dit platform',
    platformSectionHelp: 'Welke metingen dit platform mag ophalen bij elke bron waarmee je gekoppeld bent, en welke het mag terugschrijven.',
    sourcesUnreadable: 'Je koppelingen konden nu niet gelezen worden, dus deze lijst kan onvolledig zijn.',
    changeOnCoaches: 'Wat een coach mag zien verander je daar waar die een persoon is, niet een regel in een lijst.',
    goToCoaches: 'Naar mijn coaches',
    goToProviders: 'Zoek een gegevensbron',
    nothingSharedTitle: 'Er wordt nog niets gedeeld',
    nothingSharedBody: 'Je hebt geen gegevensbron gekoppeld en geen coach kan je metingen lezen.',
    title: 'Gegevenstoestemmingen',
    subtitle: 'Kies welke metingen elke verbonden bron mag lezen, en hoeveel dit platform daarvan bewaart.',
    unnamedSource: 'Naamloze bron',

    connectTitle: 'Nog een bron verbinden',
    connectSubtitle:
      'Elke server die FHIR R4 spreekt kan jouw gegevens bewaren. Niets hier is ' +
      'specifiek voor \u00e9\u00e9n aanbieder.',
    testAcceptsWrites:
      'Deze aanbieder accepteert metingen die wij erheen schrijven.',
    testReadOnly:
      'Deze aanbieder accepteert geen metingen die wij erheen schrijven; er kan ' +
      'alleen uit gelezen worden.',

    authorize: 'Autoriseren bij je aanbieder',
    authorizeFailed: 'De autorisatie kon niet worden gestart.',
    authorizeNotConfigured:
      '{{provider}} kan nog niet worden geautoriseerd: de aanbieder maakt niet ' +
      'bekend waar je moet inloggen, en er is geen adres voor ingesteld. Een ' +
      'beheerder moet dat eerst regelen.',
    alsoRequestWrite:
      'Vraag ook toestemming om metingen naar deze aanbieder te schrijven',
    authFailedTitle: 'De autorisatie is niet afgerond',
    authConnectedTitle: 'Verbonden met {{provider}}',
    authGrantedReadWrite:
      'Je aanbieder staat toe dat dit platform je metingen leest en schrijft.',
    authGrantedReadOnly:
      'Je aanbieder staat toe dat dit platform je metingen leest. Schrijven is ' +
      'niet toegestaan.',
    authGrantedNothing:
      'Je aanbieder staat niet toe dat dit platform je metingen leest, dus deze ' +
      'verbinding kan nog niets tonen.',
    authNoPatientTitle: 'Bijna verbonden',
    authNoPatientBody:
      '{{provider}} heeft niet doorgegeven welk dossier van jou is, dus de ' +
      'verbinding kon niet worden afgerond. Je autorisatie zelf is gelukt -- de ' +
      'aanbieder moet je dossier daarin meegeven, en dat kun je niet vanaf deze ' +
      'pagina aanpassen.',
    authReasons: {
      record_not_named: '{{provider}} heeft niet doorgegeven welk dossier van jou is, dus de verbinding kon niet vanzelf worden afgerond.',
      record_refused: '{{provider}} heeft deze autorisatie voor geen enkel dossier geaccepteerd. Of er staat daar nog geen dossier van jou, of dit platform mag er niet naar zoeken. Wie de bron beheert, kan je vertellen welke van de twee het is.',
      record_not_yours: '{{provider}} bood een dossier aan dat niet bij jou hoort, dus er is niets verbonden: gokken zou je de metingen van iemand anders kunnen laten zien.',
      no_record: '{{provider}} heeft nog geen dossier van jou, dus er is niets om mee te verbinden. Vraag wie de bron beheert om eerst je dossier aan te maken.',
      several_records: '{{provider}} bood meer dan één dossier aan bij deze autorisatie, dus het is niet duidelijk welk dossier van jou is. Er is niets verbonden, want gokken zou je de metingen van iemand anders kunnen laten zien.',
      record_not_served: '{{provider}} heeft niet doorgegeven welk dossier van jou is, en het dossier waar de autorisatie naar verwees werd niet gedeeld, dus de verbinding kon niet worden afgerond.',
      nothing_served: '{{provider}} heeft de autorisatie geaccepteerd, maar deelt er niets mee, dus deze verbinding kan niets laten zien.',
      write_unknown: '{{provider}} heeft niet gezegd of dit platform metingen aan je dossier mag toevoegen. Dat is dus nog een open vraag, geen weigering. Je kunt toevoegen per meting aanzetten; bij de eerste meting blijkt of je aanbieder het accepteert.',
      read_not_granted: '{{provider}} staat niet toe dat dit platform je metingen leest, dus deze verbinding kan nog niets tonen.',
      holdings_unknown: 'De verbinding is gemaakt, maar we konden nog niet lezen welke metingen {{provider}} heeft. Controleer de bron later opnieuw vanaf deze pagina.',
    },

    codesTitle: 'Metingen bij deze bron',
    checkSource: 'Bekijk wat deze bron aanbiedt',
    checkSourceHelper:
      'Vraagt de bron welke metingen zij heeft en wat zij toestaat. Het leest de ' +
      'namen van de metingen, niet hun waarden, en zet nooit een meting weer aan ' +
      'die je hebt uitgezet.',
    codesUnreadable:
      'De metingen van deze bron konden zojuist niet worden opgehaald, dus ' +
      'deze lijst laat niet zien wat je hebt toegestaan. Er is niets veranderd.',
    codesUnreadableRetry: 'Opnieuw proberen',
    nothingOffered:
      'Deze bron is nog niet bekeken, dus er staan geen metingen in de lijst. ' +
      'Bekijk wat zij aanbiedt om ze te zien.',
    nothingFound:
      'Deze bron is bekeken en gaf geen metingen terug voor je dossier, dus er ' +
      'staan er geen in de lijst.',
    nothingAddressable:
      'Deze bron is bekeken, maar haar metingen gebruiken een codestelsel dat ' +
      'dit platform niet kan opvragen, dus er staan er geen in de lijst.',
    allOff:
      'Elke meting hier staat uit, dus er wordt niets bij deze bron gelezen.',
    unmappableTitle: 'Sommige metingen kunnen hier niet worden uitgelegd',
    unmappableBody: 'Dit platform heeft geen meting voor {{count}} van de codes hieronder, dus hun waarden kunnen niet worden getoond, ook al heb je ze toegestaan. Elk ervan is in de lijst gemarkeerd; ze worden met de reden apart gehouden in plaats van weggegooid.',
    statedByYou: 'Door jou toegevoegd; niet bevestigd door de bron',

    columnMeasurement: 'Meting',
    columnAccess: 'Wat er gebeurt',
    columnRead: 'Lezen',
    columnWrite: 'Schrijven',

    access: {
      none: 'Niets',
      read: 'Alleen lezen',
      write: 'Alleen schrijven',
      'read-write': 'Lezen en schrijven',
    },

    reasonYouTurnedItOff: 'Je hebt dit uitgezet.',
    reasonSourceRefusesRead: 'Deze bron staat lezen niet toe.',
    reasonSourceRefusesWrite:
      'Deze bron accepteert geen metingen die wij erheen schrijven.',
    reasonSourceNotChecked:
      'Het is niet bekend of deze bron schrijven toestaat. Bekijk eerst wat zij ' +
      'aanbiedt.',
    reasonUnknown: 'Dit staat uit.',

    probeAdded: '{{count}} nieuwe meting(en) gevonden.',
    probeNothingNew: 'Geen nieuwe metingen gevonden.',
    probeConfirmed: '{{count}} al bekend.',
    probeUnaddressable:
      '{{count}} meting(en) gebruiken een codestelsel dat dit platform niet kan ' +
      'opvragen.',

    addCode: 'LOINC-code toevoegen',
    addCodeHelper:
      'Alleen nodig voor een meting die deze bron gaat bewaren maar nog niet ' +
      'heeft. Bijvoorbeeld 29463-7.',
    add: 'Toevoegen',
    invalidCode: 'Dat is geen LOINC-code. Een LOINC-code ziet uit als 29463-7.',
    addFailed: 'De code kon niet worden toegevoegd.',
    updateFailed: 'Het recht kon niet worden gewijzigd.',
    probeFailed: 'De bron kon niet worden bekeken.',
    scopeSaved: '{{name}}: {{state}}.',
    codeAdded: '{{code}} toegevoegd.',
    writeMovedFrom:
      'Schrijven stond nog aan bij {{source}}, waar het niets kon doen. Dat is ' +
      'nu uitgezet: één bron schrijft een meting.',

    columnAvailable: 'In dit platform',
    availableHere: 'Beschikbaar',
    notAvailableHere: 'Niet beschikbaar',
    notAvailableHelp: 'Dit platform heeft geen meting voor deze code, dus waarden eronder kunnen niet worden getoond, ook niet als je ze toestaat.',
    unknownCode: 'Geen code die dit platform herkent',
    nothingOfferedEnded: 'Voor deze verbinding zijn geen metingen vastgelegd voordat zij werd beëindigd.',
    providerSearchPlaceholder: 'Zoek op naam of adres',
    providerSearchHelper:
      'Typ een deel van de naam. Zorgverleners waarmee je organisatie een ' +
      'overeenkomst heeft, plus servers die je zelf hebt toegevoegd.',
    providerMoreMatches: 'Nog {{count}} andere passen bij wat je typte — typ verder om te verfijnen.',
    providerNoMatches: 'Geen zorgverlener of server past daarbij.',
    yourServer: 'Door jou toegevoegd',
    addServer: 'FHIR-server toevoegen',
    addServerTitle: 'FHIR-server toevoegen',
    addServerBody:
      'Elke server die FHIR R4 spreekt kan metingen bewaren. Voor wie hij is ' +
      'bepaalt wie hem ziet en wie hem kan verwijderen. Dit platform staat ' +
      'niet in voor de server zelf, dus controleer het adres voordat je opslaat.',
    serverName: 'Hoe je hem noemt',
    serverNameHelp: 'De naam die iedereen leest die deze server kan zien.',
    serverAddress: 'Adres van de FHIR-server',
    serverAddressHelp:
      'Het basisadres, waar /metadata en /Observation onder vallen.',
    serverAuth: 'Hoe hij controleert wie er vraagt',
    serverAuthHelp:
      'Kies wat je server verwacht. Test daarna de verbinding om het zeker te weten.',
    authNone: 'Geen inloggegevens nodig',
    authBearer: 'Een token',
    authBasic: 'Een gebruikersnaam en wachtwoord',
    authOauth: 'Aanmelden bij de server (OAuth 2.0)',
    serverToken: 'Het token',
    serverUsername: 'Gebruikersnaam',
    serverUsernameHelp:
      'De naam die je server verwacht, precies zoals je die zelf zou intypen ' +
      'om daar in te loggen.',
    serverPassword: 'Wachtwoord',
    usernameHasColon:
      'Een gebruikersnaam mag geen dubbele punt bevatten. De dubbele punt ' +
      'scheidt de gebruikersnaam van het wachtwoord, dus alles erachter wordt ' +
      'als deel van het wachtwoord verstuurd.',
    serverSecretHelp:
      'Versleuteld voordat het wordt opgeslagen en nooit meer getoond, hier ' +
      'noch elders. Het wordt alleen gebruikt om je eigen server te bevragen.',
    serverReturnAddress: 'Terugkeeradres',
    serverReturnAddressHelp: 'Registreer dit adres bij de server voor de client die dit platform daar krijgt. De server stuurt je hierheen terug nadat je je hebt aangemeld.',
    copyReturnAddress: 'Kopiëren',
    returnAddressCopied: 'Terugkeeradres gekopieerd',
    returnAddressCopyFailed: 'Het terugkeeradres kon niet worden gekopieerd. Selecteer het en kopieer het zelf.',
    serverClientId: 'Client-id',
    serverClientIdHelp: 'Het id dat de server dit platform gaf toen het daar werd geregistreerd.',
    serverClientSecret: 'Clientgeheim',
    serverClientSecretHelp: 'Alleen als de server er een gaf. Versleuteld voordat het wordt opgeslagen en nooit meer getoond.',
    serverRecordClaim: 'Claim die je dossier noemt',
    serverRecordClaimHelp: 'Alleen voor een server waarvan de aanmelding een kenmerk meegeeft in plaats van je dossier. Laat dit en het volgende veld anders leeg.',
    serverRecordSystem: 'Systeem van het kenmerk',
    serverRecordSystemHelp: 'Het systeem waaronder dat kenmerk bij de server bekend is.',
    recordPairIncomplete: 'Vul beide velden in, of geen van beide.',
    testAddress: 'Dit adres testen',
    testUsable: 'Antwoordt als FHIR {{version}}. {{software}}',
    testNotFhir: 'Er antwoordde iets, maar niet als FHIR R4-server.',
    testMissingResources:
      'Dit is een FHIR R4-server, maar hij biedt niet de dossiers en metingen die dit platform leest.',
    testUnreachable: 'Op dat adres antwoordde niets.',
    testFailed: 'Het adres kon niet getest worden.',
    columnName: 'Naam',
    registerServer: 'Server opslaan',
    ownServerRegistered: '{{name}} is toegevoegd. Maak hieronder verbinding.',
    ownServerFailed: 'Die server kon niet worden toegevoegd.',
    startsKeepingNothing:
      'Een nieuwe verbinding bewaart niets op dit platform: je metingen worden ' +
      'bij je zorgverlener opgehaald terwijl je ernaar kijkt. Je kunt dit ' +
      'platform daarna een kopie laten bewaren, op de verbinding zelf.',
    yourSources: 'Jouw bronnen ({{count}})',
    searchSources: 'Zoek in je bronnen',
    noSourcesMatch: 'Geen van je bronnen past bij “{{query}}”.',
  },
  remoteStorage: {
    storedHere: 'Opgeslagen op dit platform',
    storedHereNotice: 'Dit platform bewaart uw metingen en is daarvoor verantwoordelijk. Hieronder kunt u ze onderbrengen bij uw eigen zorgverlener.',
    sourcesUnknown: 'Uw koppelingen konden niet worden opgehaald',
    sourcesUnknownNotice: 'We konden niet nagaan waar uw metingen worden bewaard. Ververs de pagina; wijzig hier voorlopig niets, want dit scherm laat nu niet zien welke koppelingen actief zijn.',
    provider: 'Zorgverlener',
    copyExpiry: 'Kopie bewaren voor',
    expiryIndefinite: 'Onbeperkt',
    testConnection: 'Verbinding testen',
    testUsable: '{{software}} bereikt, spreekt FHIR {{version}}. Deze zorgverlener kan gebruikt worden.',
    testFailed: 'Kon die zorgverlener niet bereiken',

    testThisSource: 'Deze bron testen',
    healthWorking: 'Antwoordt',
    healthWorkingHelp:
      'De laatste keer dat dit platform deze bron heeft gelezen, op {{when}}, ' +
      'gaf die antwoord. Gebruik “Deze bron testen” om het nu opnieuw te '
      + 'controleren.',
    healthFailing: 'Antwoordt niet',
    healthFailingHelp:
      'De laatste poging om deze bron te lezen, op {{when}}, is niet gelukt: ' +
      '{{detail}}',
    healthUntried: 'Nog niet gebruikt',
    healthUntriedHelp:
      'Er is nog niets uit deze bron gelezen, dus er is nog niets te zeggen ' +
      'over of die antwoordt. Gebruik “Deze bron testen” om dat te weten.',
    checkOk:
      '{{software}} gaf antwoord, accepteerde dit platform en heeft jouw ' +
      'dossier nog.',
    checkCredentialRefused:
      'Deze bron gaf antwoord maar weigerde de opgeslagen inloggegevens, dus er ' +
      'kan niets uit gelezen worden. Heb je deze server zelf toegevoegd? Voeg ' +
      'hem dan opnieuw toe met inloggegevens die werken.',
    checkUnreachable: 'Deze bron was niet bereikbaar: {{detail}}',
    checkRecordMissing:
      'Deze bron gaf antwoord, maar heeft het dossier waar deze verbinding naar ' +
      'wijst niet meer. Er kan niets gelezen worden zolang die verwijzing niet ' +
      'klopt.',
    checkNotUsable:
      'Deze bron gaf antwoord, maar niet op een manier die dit platform kan ' +
      'lezen: {{detail}}',
    checkFailed: 'De controle kon niet worden uitgevoerd.',
    checkedWorking: 'Deze bron werkt.',
    checkedNeedsAttention: 'Deze bron vraagt aandacht.',
    checkedWentWrong: 'Er ging iets mis met deze bron.',
    connect: 'Verbinden',
    invalidExpiry: 'Kies hoe lang een kopie bewaard mag worden',
    retentionUpdateFailed: 'Kon uw bewaarinstelling niet aanpassen',
    syncNow: 'Nu ophalen',
    syncFailed: 'Kon niet ophalen bij uw zorgverlener',
    inconsistentTitle: 'Dit klopt niet',
    inconsistentBody: 'U heeft aangegeven dat wij geen kopie mogen bewaren, maar er staan hier nog {{count}} meting(en). Meld dit alstublieft.',
    endConnection: 'Verbinding beëindigen',
    endConnectionTitle: 'Deze verbinding beëindigen?',
    endConnectionBody: 'Uw verbinding wordt gesloten en elke kopie van uw gegevens op dit platform wordt verwijderd. Uw zorgverlener houdt het eigen dossier, tenzij u ons vraagt het daar ook te verwijderen.',
    alsoDeleteAtProvider: 'Vraag mijn zorgverlener ook te verwijderen wat dit platform daar heeft geschreven',
    confirmEnd: 'Verbinding beëindigen',
    revokeFailed: 'Kon de verbinding niet beëindigen',
    cancel: 'Annuleren',
    endedConnections: 'Verbindingen die u heeft beëindigd',
    endedOn: 'Beëindigd {{when}}',

    modes: {
      zeroRetention: {
        label: 'Bewaar hier niets',
        benefit:
          'Uw gezondheidsgegevens staan nooit op dit platform. Beëindigt u de verbinding, dan blijft er niets achter — er was niets.',
        cost:
          'Schermen zijn langzamer, en is uw zorgverlener niet bereikbaar, dan zijn uw gegevens helemaal niet beschikbaar.',
      },
      cache: {
        label: 'Bewaar een kopie in de cache',
        benefit:
          'Schermen zijn snel en uw gegevens blijven zichtbaar wanneer uw zorgverlener niet bereikbaar is.',
        cost:
          'Een kopie van uw gegevens staat op dit platform zolang u zelf kiest, en valt dan onder de beveiliging van dit platform en niet alleen onder die van uw zorgverlener.',
      },
      local: {
        label: 'Bewaar het op dit platform',
        benefit:
          'Alles werkt zoals nu, met volledige controle op de samenhang tussen uw gegevens.',
        cost:
          'Dit platform bewaart uw gezondheidsgegevens en is verantwoordelijk voor het bewaren daarvan. U kiest dit door geen verbinding met een zorgverlener te hebben.',
      },
    },

    noticeCache:
      'Uw metingen staan bij uw zorgverlener. Dit platform bewaart maximaal {{expiry, minutes}} een kopie, zodat schermen snel blijven en beschikbaar zijn als uw zorgverlener eruit ligt.',
    noticeCacheIndefinite:
      'Uw metingen staan bij uw zorgverlener. Dit platform bewaart een kopie totdat u de verbinding beëindigt, zodat schermen snel blijven en beschikbaar zijn als uw zorgverlener eruit ligt. De kopie wordt ververst als u zelf ophaalt of iets vastlegt, niet vanzelf.',
    noticeZeroRetention:
      'Uw metingen staan bij uw zorgverlener. Dit platform bewaart geen kopie: gegevens worden opgehaald terwijl u ernaar kijkt en niet vastgehouden.',

    syncRead: '{{count}} meting(en) opgehaald bij uw zorgverlener.',
    syncUnchangedAll: 'Er was niets gewijzigd.',
    syncChanged: '{{written}} nieuw, {{replaced}} gecorrigeerd, {{unchanged}} ongewijzigd.',
    syncQuarantined:
      '{{count}} kon niet worden uitgelegd en wordt niet getoond. Je pagina ' +
      'met gegevensinstellingen benoemt ze.',
    revokeNothingChanged: 'De verbinding kon niet worden beëindigd. Er is niets gewijzigd.',
    revokePurged: 'Verbinding beëindigd en {{count}} hier bewaarde meting(en) verwijderd.',
    revokeRemoteConfirmed:
      'Uw zorgverlener heeft bevestigd te hebben verwijderd wat wij daar hadden geschreven.',
    revokeRemoteFailed: 'Uw gegevens staan nog bij uw zorgverlener: {{detail}}',

    ttlNotApplicable:
      'Een bewaartermijn hoort niet bij deze stand: er wordt niets bewaard, dus verloopt er ook niets.',
    ttlNotWhole: 'De bewaartermijn moet een heel aantal minuten zijn.',
    ttlOutOfRange:
      'De bewaartermijn moet tussen {{min}} minuten en 7 dagen liggen, of kies dat de kopie niet verloopt.',
  },
  recordPage: {
    path: 'Pad',
    general: 'Algemeen',
  },
  programmePage: {
    measurements: 'Metingen',
    dashboards: 'Dashboard',
    notFoundTitle: 'Dit programma is niet gevonden',
    notFoundBody: 'Het is misschien verwijderd, of het hoort bij een andere organisatie.',
    loadFailedTitle: 'Dit programma kon niet worden gelezen',
    loadFailed: 'Probeer het zo nog eens.',
    people: 'Deelnemers',
  },
  programmeBoards: {
    loading: 'Het dashboard wordt geladen',
    panelTitle: 'Het dashboard van dit programma',
    panelHint: 'Elk lid van dit programma vindt het op het eigen dashboard zodra er een blok op staat. Wat je bewaart, zien ze meteen.',
    name: 'Naam',
    nameHint: 'Leeg gelaten krijgt het de naam van het programma.',
    unsaved: 'Niet bewaard',
    save: 'Opslaan',
    discard: 'Wijzigingen weggooien',
    saved: 'Bewaard. Leden van dit programma zien het nu.',
    saveFailed: 'Het dashboard kon niet worden bewaard. Probeer het opnieuw.',
    emptyTitle: 'Dit dashboard is nog leeg',
    emptyBody: 'Kies hierboven een blok. Leden zien het dashboard zodra er een op staat.',
    deniedTitle: 'Je kunt het dashboard van dit programma niet aanpassen',
    deniedBody: 'Daarvoor heb je het recht nodig om dit programma in te richten.',
    loadFailedTitle: 'Het dashboard kon niet worden gelezen',
    retry: 'Opnieuw proberen',
    galleryHint: 'Kies een blok om het onderaan dit dashboard te zetten. Elk blok toont een meting van dit programma.',
    arrangeHint: 'Sleep een blok aan het greepje, of trek aan de rechteronderhoek. Elk lid ziet er de eigen waarden in.',
    noMeasurements: 'Dit programma volgt nog geen meting. Voeg er eerst een toe op het tabblad Metingen.',
  },
  questionnairePage: {
    questions: 'Vragen',
    submissions: 'Inzendingen',
    notFoundTitle: 'Deze vragenlijst is niet gevonden',
    notFoundBody: 'Hij is misschien verwijderd, of hij hoort bij een andere organisatie.',
    loadFailedTitle: 'Deze vragenlijst kon niet worden gelezen',
    loadFailed: 'Probeer het zo nog eens.',
  },
  tenantPage: {
    administrators: 'Beheerders',
    notFoundTitle: 'Deze tenant is niet gevonden',
    notFoundBody: 'Hij is misschien verwijderd, of het adres klopt niet.',
    loadFailedTitle: 'Deze tenant kon niet worden gelezen',
    loadFailed: 'Probeer het zo nog eens.',
    table: {
      name: 'Naam',
      email: 'E-mail',
    },
    addButton: 'Beheerder toevoegen',
    remove: 'Verwijderen',
    removeTitle: 'Beheerder verwijderen',
    removeMessage: '{{name}} beheert {{tenant}} dan niet meer. Het account en het lidmaatschap blijven.',
    removed: 'Beheerder verwijderd',
    added: 'Beheerder toegevoegd',
    add: {
      title: 'Beheerder toevoegen aan {{tenant}}',
      person: 'Persoon',
      personRequired: 'Kies een persoon',
      nobody: 'Niemand in deze organisatie kan worden gekozen.',
      peopleFailed: 'De mensen van deze organisatie konden niet worden gelezen.',
      save: 'Toevoegen',
      failed: 'De beheerder kon niet worden toegevoegd.',
    },
  },
  grid: {
    noRowsTitle: 'Nog niets',
    noRowsNotice: 'Rijen verschijnen zodra er iets te zien is.',
    noResultsTitle: 'Niets gevonden',
    noResultsNotice: 'Zoek korter, of wis de filters.',
    actions: 'Acties',
    moreActions: 'Meer acties',
    edit: 'Bewerken',
    remove: 'Verwijderen',
    clearSearch: 'Zoekopdracht wissen',
    cancel: 'Annuleren',
    save: 'Opslaan',
    saving: 'Opslaan…',
    actionFailed: 'Dat lukte niet. Er is niets veranderd.',
    loadFailedTitle: 'Deze lijst kon niet worden gelezen',
    add: 'Toevoegen',
    filter: 'Filter',
    searchAll: 'Zoek in alle kolommen',
    sortByField: 'Sorteren op: {{field}}',
    sortByFieldDirection: 'Sorteren op: {{field}}, {{direction}}',
    filterWithCount: 'Filter ({{count}})',
    newestFirst: 'Nieuwste eerst',
    noResultsFor: 'Geen resultaten voor “{{query}}”',
    clearSearchAndFilters: 'Zoekterm en filters wissen',
    tryAgain: 'Opnieuw proberen',
    rowsPerPage: 'Rijen per pagina',
    range: '{{from}}–{{to}} van {{count}}',
    previousPage: 'Vorige pagina',
    nextPage: 'Volgende pagina',
  },
  coaches: {
    title: 'Coaches',
    subtitle:
      'De coaches die jouw organisatie aanbiedt. Jij kiest wie je vraagt, en ' +
      'wat die persoon van jouw metingen mag zien.',
    coachingSubtitle: 'De mensen die je begeleidt, de verzoeken aan jou, en hoe de lijst met coaches jou toont.',
    unnamedCoach: 'Coach zonder naam',
    unnamedMember: 'Deelnemer zonder naam',

    requestPendingChip: 'Verzoek verstuurd',
    ask: 'Vraag deze coach',
    details: 'Details',
    withdrawRequest: 'Verzoek intrekken',
    access: {
      held: 'Ziet {{see}} van jouw metingen en mag {{record}} invoeren.',
      asked: 'Vraagt om {{see}} metingen te zien en {{record}} in te voeren.',
    },
    cannotAsk: {
      alreadyMyCoach: 'Deze coach ziet jouw metingen al.',
      requestPending: 'Jouw verzoek wacht nog op een antwoord.',
      notAccepting: 'Deze coach neemt nu geen nieuwe mensen aan.',
    },

    askTitle: '{{name}} vragen',
    askExplainer:
      'Kies wat deze coach mag zien. Je past het aan, of beëindigt het, ' +
      'wanneer je wil bij jouw coaches.',
    measurement: 'Meting',
    maySee: 'Mag zien',
    mayRecord: 'Mag invoeren',
    maySeeAria: 'Mag {{name}} zien',
    mayRecordAria: 'Mag {{name}} invoeren',
    messageLabel: 'Bericht (optioneel)',
    sendRequest: 'Verzoek versturen',
    askFailed: 'Het verzoek kon niet worden verstuurd.',
    scopesUnavailable: 'De metingen van jouw programma konden niet worden gelezen.',
    noProgrammeYet:
      'Je volgt nog geen programma, en wat je kunt delen komt uit het programma.',
    someUnsharable:
      'Nog niet te delen: {{names}}. Deze metingen hebben geen LOINC-code — vraag een beheerder er een aan te koppelen.',
    noMeasurementsYet:
      'Jouw programma noemt nog geen metingen, dus er is nog niets te delen.',

    waitingForYou: 'Wacht op jouw antwoord',
    stillWaiting: 'Wacht nog op antwoord',
    earlierRequests: 'Eerdere verzoeken',
    offeredAccess: 'Waar ze om vragen',
    sharedProgrammes: 'Programma\'s die jullie delen',
    askedOn: 'Gevraagd op {{when}}',
    answerableUntil: 'Te beantwoorden tot {{when}}',
    expiredOn: 'Verlopen op {{when}}',
    expired: 'Verlopen',
    accept: 'Accepteren',
    decline: 'Afwijzen',
    declineTitle: 'Verzoek afwijzen',
    declineReasonLabel: 'Reden (optioneel)',
    actionFailed: 'Dat lukte niet.',
    status: {
      pending: 'Wacht op antwoord',
      accepted: 'Geaccepteerd',
      declined: 'Afgewezen',
      withdrawn: 'Ingetrokken',
      expired: 'Verlopen',
    },

    myListing: 'Jouw coachprofiel',
    myListingExplainer:
      'Alleen jij zet dit profiel in de lijst. Dat staat los van je ' +
      'deelinstelling voor de gemeenschap.',
    listingSaved: 'Coachprofiel opgeslagen.',
    saveFailed: 'Het profiel kon niet worden opgeslagen.',
    headlineLabel: 'Korte omschrijving',
    bioLabel: 'Over jou',
    programmesLabel: 'Programma\'s die je begeleidt',
    maxMembersLabel: 'Maximaal aantal mensen',
    maxMembersHelp_one: 'Je begeleidt nu {{count}} persoon.',
    maxMembersHelp_other: 'Je begeleidt nu {{count}} mensen.',
    acceptingLabel: 'Open voor nieuwe mensen',
    publishLabel: 'Adverteren in mijn organisatie',
    publishNeedsBoth:
      'Een profiel in de lijst heeft een korte omschrijving en een stukje over ' +
      'jou nodig: daarop kiest iemand.',

    peopleYouFollow: 'Mensen die je begeleidt',
    peopleYouFollowExplainer:
      'Wat je van iemand mag zien, bepaalt die persoon zelf.',

    directoryUnknown: 'De lijst kon niet worden gelezen',
    directoryUnknownNotice: 'Probeer het later opnieuw.',
    onlyYouListedTitle: 'Jij bent de enige coach in de lijst',
    onlyYouListedNotice:
      'Er staan nog geen andere coaches van jouw organisatie in de lijst.',
    noneListedTitle: 'Nog geen coaches in de lijst',
    noneListedNotice:
      'Zodra een coach van jouw organisatie een profiel plaatst, staat die hier.',
    canAsk: 'Coaches die je kunt vragen',
    allAlreadyYoursTitle: 'Nog geen andere coaches',
    allAlreadyYoursNotice: 'De coaches die jou al begeleiden staan hierboven. Andere coaches uit jouw organisatie staan hier zodra ze een profiel plaatsen.',
    onlyAccepting: 'Alleen wie nieuwe mensen aanneemt',
    search: 'Zoek een coach',
    noneAcceptingTitle: 'Niemand neemt nu nieuwe mensen aan',
    noneAcceptingNotice: 'Geen van de coaches in de lijst staat op dit moment open voor nieuwe mensen.',
    listingUnknownTitle: 'Jouw coachprofiel kon niet worden gelezen',
    listingUnknown: 'Wat je hier ziet kan verouderd zijn.',
    noListingTitle: 'Je hebt geen coachprofiel',
    noListing:
      'Op dit scherm past een coach het profiel aan dat deelnemers zien. Jouw account heeft geen coachrol, dus er is hier nog niets aan te passen.',
    grantsUnknownTitle: 'Jouw coaches konden niet worden gelezen',
    grantsUnknown: 'Wat je hier ziet kan verouderd zijn.',
    noneMatchTitle: 'Geen coach gevonden',
    noneMatchNotice: 'Niets past bij "{{query}}". Probeer een deel van een naam of een programma.',

    myCoaches: 'Jouw coaches',
    changeOnCoaches:
      'Welke metingen een coach mag zien, pas je aan op de pagina Coaches.',
    whatTheyMaySee: 'Wat deze coach mag zien',
    sinceExplainer:
      'Je gaf deze toegang op {{when}}. Aanpassingen gelden meteen.',
    saveAccess: 'Aanpassing opslaan',
    accessSaved: 'Aanpassing opgeslagen.',
    accessSaveFailed: 'De aanpassing kon niet worden opgeslagen.',
    keepOneOrEnd:
      'Laat minstens één meting staan, of beëindig de toegang — dan hoort de coach het ook.',
    nothingShared: 'Er wordt niets met deze coach gedeeld.',
    accessEndedOn: 'Deze toegang is beëindigd op {{when}}.',
    offerUnreadable:
      'De metingen van jouw programma konden niet worden gelezen, dus je ziet alleen wat al gedeeld wordt.',
    endCoaching: 'Toegang beëindigen',
    endCoachingTitle: 'Toegang beëindigen',
    endCoachingBody:
      '{{name}} kan jouw metingen daarna niet meer zien. Wat al is vastgelegd ' +
      'blijft staan.',
    grantedOn: 'Toegang gegeven op {{when}}',
    endedCoaching: 'Beëindigde begeleiding',
    endedOn: 'Beëindigd op {{when}}',
    revokeFailed: 'De toegang kon niet worden beëindigd.',

    tabs: {
      coaches: 'Mijn coaches',
      history: 'Historie',
      listing: 'Mijn coachprofiel',
      requests: 'Verzoeken aan mij',
      members: 'Mensen die ik begeleid',
    },

    noProgrammeTitle: 'Je volgt nog geen programma',
    noProgrammeNotice: 'Een coach begeleidt een programma. Zodra je aan een programma meedoet, zie je hier de coaches die dat programma begeleiden.',
    noHistoryTitle: 'Nog niets om terug te kijken',
    noHistoryNotice: 'Begeleiding die is geëindigd en verzoeken die op niets uitliepen, blijven hier staan.',
    peopleYouCoached: 'Mensen die je hebt begeleid',
    noPastMembersTitle: 'Niemand is gestopt',
    noPastMembersNotice: 'Iedereen die je begeleidt doet nog mee. Begeleiding die eindigt, staat hier.',
    noOpenRequestsTitle: 'Geen verzoeken die wachten',
    noOpenRequestsNotice: 'Als iemand jou om begeleiding vraagt, staat dat verzoek hier.',
    answeredRequests: 'Beantwoorde verzoeken',
    noMembersYetTitle: 'Je begeleidt nog niemand',
    noMembersYetNotice: 'Zodra iemand jouw verzoek accepteert, staat die persoon hier, met wat je mag zien.',
    memberUnreadableTitle: 'Deze metingen konden niet worden gelezen',
    memberUnreadable: 'Probeer het straks nog eens.',
    nothingPermittedTitle: 'Niets om te tonen',
    nothingPermittedNotice: 'De programma\'s van deze persoon noemen geen metingen die met jou gedeeld kunnen worden.',
    nothingSharedWithYouTitle: 'Nog niets gedeeld',
    nothingSharedWithYouNotice: 'Deze persoon heeft nog geen metingen met jou gedeeld. Wat gedeeld zou kunnen worden staat hieronder.',
    notShared: 'Niet met jou gedeeld',
    notSharedNotice: 'Deze persoon heeft deze meting niet gedeeld, dus er wordt niets over getoond.',
    sourceUnavailable: 'Bron gaf geen antwoord',
    sourceIncomplete: 'Deels onleesbaar',
    sourceIncompleteNotice: 'Sommige waarden van deze bron konden niet gelezen worden, dus wat hier staat is niet alles.',
    sourceSilent: 'De bron met deze waarden gaf geen antwoord',
    sourceRefused: 'Bron niet leesbaar voor jou',
    sourceNotReadForYou: 'De bron met deze waarden kan niet namens jou worden gelezen',
    recordedHere: 'Vastgelegd op dit platform',
    fromSourceAsOf: 'Van {{source}}, opgehaald {{when}}',
    asOfUnknown: 'op een onbekend moment',
    mixedSources: 'Waarden komen uit {{places}} verschillende bronnen, dus er wordt geen verschil getoond.',
    sourcesDegradedTitle: 'Er kunnen waarden ontbreken',
    sourcesDegraded: 'Geen antwoord van {{names}}. Waarden die daar staan kunnen op dit scherm ontbreken.',
    sourcesRefusedTitle: 'Sommige waarden kunnen niet worden getoond',
    sourcesRefused: '{{names}} kan niet namens jou worden gelezen, dus waarden die daar staan ontbreken op dit scherm. Dat gaat over de toegang tussen die bron en dit platform, niet over wat deze persoon met jou heeft gedeeld.',
    sourceNotConnectedChip: 'Niet verbonden',
    sourceNotConnectedCaption: 'Verbind je eigen account om de waarden bij deze bron te lezen',
    sourcesNotConnectedTitle: 'Verbind om sommige waarden te lezen',
    sourceNotConnected: '{{name}} kan alleen met je eigen account worden gelezen. Verbind het één keer, dan kunnen de waarden die deze persoon met jou deelde hier worden getoond.',
    sourceReconnect: 'Je verbinding met {{name}} is beëindigd, dus waarden die daar staan zijn niet op dit scherm. Verbind opnieuw om te lezen wat deze persoon met jou deelde.',
    connectSource: 'Verbind {{name}}',
    reconnectSource: 'Verbind {{name}} opnieuw',
    connectedTitle: 'Verbonden met {{source}}',
    connectedBody: 'Open deze persoon opnieuw om de gedeelde waarden te lezen.',
    connectFailedTitle: 'De verbinding kon niet worden gemaakt',
    connectFailedBody: 'Er is niets gewijzigd. Probeer het later opnieuw.',
    notConnectedTitle: 'Niet verbonden met {{source}}',
    connectReasons: {
      refused: '{{source}} heeft de aanmelding niet geaccepteerd, dus er is niets verbonden.',
      no_code: 'De aanmelding bij {{source}} gaf niets terug, dus er is niets verbonden.',
      no_party_id: 'Je account bij {{source}} heeft nog geen JLAM-ID, dus het kan je daar niet noemen. Vraag het aan wie de accounts beheert.',
      no_person: 'Je account hier is niet aan een persoon gekoppeld, dus het kan niet worden verbonden.',
    },
    sourcesStaleTitle: 'Sommige waarden kunnen verouderd zijn',
    sourcesStale: 'We konden {{names}} niet verversen. Wat daar sinds de laatste controle is vastgelegd, ontbreekt op dit scherm.',
    withheldFromHistory: 'Niet met jou gedeeld: {{names}}',
    source: 'Bron',
    asOf: 'Opgehaald',
    here: 'Dit platform',
    lastRecorded: 'Laatst vastgelegd op {{when}}',
    lastRecordedByYou: 'Laatst door jou vastgelegd op {{when}}',
    noReadingYet: 'Nog geen waarde vastgelegd',
    readOnlyHere: 'Alleen inzien',
    newValue: 'Nieuwe waarde',
    unit: 'Eenheid',
    measuredAt: 'Gemeten op',
    momentInFuture: 'Een meting kan niet in de toekomst liggen.',
    recordedSome_one: '{{count}} waarde vastgelegd; de rest niet.',
    recordedSome_other: '{{count}} waarden vastgelegd; de rest niet.',
    record: 'Vastleggen',
    recorded_one: '{{count}} waarde vastgelegd.',
    recorded_other: '{{count}} waarden vastgelegd.',
    recordFailed: 'De waarde kon niet worden vastgelegd.',
    nothingToRecord: 'Vul eerst een waarde in.',
    valueNotANumber: 'Deze meting verwacht een getal.',
    requestSent: 'Verzoek verstuurd naar {{name}}.',
    requestAccepted: 'Je begeleidt nu {{name}}.',
    requestDeclined: 'Verzoek van {{name}} afgewezen.',
    requestWithdrawn: 'Verzoek aan {{name}} ingetrokken.',
    accessEnded: '{{name}} kan jouw metingen niet meer zien.',
    findSomeoneYouCoach: 'Zoek iemand die je begeleidt',
    personColumn: 'Persoon',
    sinceColumn: 'Sinds',
    trendColumn: 'Trend',
    lastActivityColumn: 'Laatst vastgelegd',
    lastActivityNever: 'Nog niets vastgelegd',
    lastActivityOn: 'Laatst vastgelegd op {{when}}',
    searchMembers: 'Zoek in de mensen die je begeleidt',
    noMatchesTitle: 'Niemand komt overeen',
    noMatchesNotice: 'Probeer een kortere zoekterm, of maak het vak leeg.',
    openMember: 'Open {{name}}',
    caseloadUnknownTitle: 'De mensen die je begeleidt konden niet worden gelezen',
    caseloadUnknownNotice: 'Probeer het straks nog een keer.',
    jumpToAnother: 'Ga naar iemand anders',
    memberNotInCaseloadTitle: 'Niet iemand die je begeleidt',
    memberNotInCaseloadNotice: 'Deze persoon staat niet in je lijst. De begeleiding kan zijn geëindigd, of de link is oud.',
    trendNothing: 'Nog niets gedeeld',
    trendInRange_one: '{{count}} binnen streefbereik',
    trendInRange_other: '{{count}} binnen streefbereik',
    trendToward_one: '{{count}} beweegt naar de streefwaarde',
    trendToward_other: '{{count}} bewegen naar de streefwaarde',
    trendAway_one: '{{count}} beweegt van de streefwaarde af',
    trendAway_other: '{{count}} bewegen van de streefwaarde af',
    trendTracked_one: '{{count}} meting gevolgd',
    trendTracked_other: '{{count}} metingen gevolgd',
    coachingSince: 'Begeleiding sinds {{when}}',
    viewTrends: 'Trends',
    viewHistory: 'Historie',
    recordedAt: 'Vastgelegd',
    value: 'Waarde',
    recordedBy: 'Vastgelegd door',
    you: 'Jij',
    noReadingsTitle: 'Nog niets vastgelegd',
    noReadingsNotice: 'Waarden die voor deze persoon zijn vastgelegd staan hier, nieuwste eerst.',
  },
  manageRoles: {
    noTenantNotice: 'Rollen horen bij een organisatie, en dit account hoort bij geen enkele.',
    noTenantTitle: 'Geen organisatie om rollen van te tonen',
  },
  rolePermissions: {
    label: 'Pagina\'s en acties per rol',
    page: 'Pagina',
    pageAction: 'Pagina / actie',
    rolePicker: 'Rol',
    allRoles: 'Alle rollen',
    search: 'Zoek pagina\'s, acties of adressen',
    filter: 'Toon',
    filterAll: 'Alles',
    notEnforced: 'Nog niet actief',
    notEnforcedHint: 'De API controleert deze actie nog niet. Je legt hier vast wat de bedoeling is; effect heeft het nog niet.',
    destructive: 'apart aanzetten',
    destructiveHint: 'Deze actie haalt toegang weg of deelt rechten uit, en komt daarom nooit vanzelf mee uit een basisrol. Je zet hem per rol bewust aan.',
    alwaysAvailable: 'Altijd beschikbaar',
    controlLabel: '{{role}}: {{item}}',
    pageOff: '{{page}} staat uit voor {{role}}',
    notOffered: 'Niet aangeboden aan {{role}}',
    noResultsTitle: 'Geen rechten gevonden voor “{{query}}”',
    noResultsFilterTitle: 'Geen rechten bij dit filter',
    noResultsBody: 'Controleer de spelling of zet het filter op Alles.',
    clear: 'Zoeken en filter wissen',
    changes: '{{changes}} in {{roles}}',
    changeCount_one: '{{count}} niet-opgeslagen wijziging',
    changeCount_other: '{{count}} niet-opgeslagen wijzigingen',
    changesShort: '{{changes}} · {{roles}}',
    changeCountShort_one: '{{count}} wijziging',
    changeCountShort_other: '{{count}} wijzigingen',
    roleCount_one: '{{count}} rol',
    roleCount_other: '{{count}} rollen',
    allSaved: 'Alles opgeslagen',
    discard: 'Verwerpen',
    save: 'Wijzigingen opslaan',
    saveShort: 'Opslaan',
    saving: 'Opslaan…',
    saved: 'Rechten opgeslagen',
    savedEverywhere: 'Rechten opgeslagen; elke organisatie die deze rollen volgt, heeft ze nu',
    saveFailed: '{{role}} is niet opgeslagen: {{reason}}',
    saveFailedReason: 'de server weigerde het',
    loadFailedTitle: 'De rollen konden niet worden gelezen',
    members_one: '{{count}} lid',
    members_other: '{{count}} leden',
    organisations_one: '{{count}} organisatie',
    organisations_other: '{{count}} organisaties',
    reachNotice: 'Wat je hier wijzigt, geldt voor elke organisatie die over die pagina of actie zelf niets heeft besloten.',
    grantedTo: 'Gegeven aan {{roles}}',
    grantedToNone: 'Aan geen enkele rol gegeven',
    sheetPageContext: '{{group}} · pagina {{route}}',
    sheetActionContext: '{{group}} · {{page}}',
    pageVisible: 'Pagina zichtbaar',
    pageHidden: 'Pagina verborgen',
    pageOffForRole: 'De pagina {{page}} staat uit voor deze rol',
    done: 'Klaar',
    sections: {
      member: 'Deelnemerpagina\'s',
      manage: 'Beheer',
      account: 'Account',
      admin: 'Administratie',
    },
  },
  roleList: {
    add: 'Rol toevoegen',
    edit: 'Rol bewerken',
    remove: 'Rol verwijderen',
    columns: {
      name: 'Naam',
      heldBy: 'Gegeven aan',
      inheritsFrom: 'Erft van',
      description: 'Omschrijving',
      ownChanges: 'Eigen keuzes',
      pages: 'Pagina\'s',
      actions: 'Acties',
      kind: 'Soort',
    },
    people_one: '{{count}} persoon',
    people_other: '{{count}} personen',
    ownRole: 'Eigen rol',
    followsBase: 'Volgt de basisrol',
    ownChanges_one: '{{count}} eigen keuze',
    ownChanges_other: '{{count}} eigen keuzes',
    platformRole: 'Platformrol',
    organisationRole: 'Rol van de organisatie',
    platformNameFixed: 'Het platform zoekt deze rol op naam op, dus naam en omschrijving blijven zoals ze zijn. Wat de rol mag, wijzig je bij Rolrechten.',
    platformRoleKept: 'Het platform zoekt deze rol op naam op, dus hij kan niet weg.',
    heldRoleKept_one: '{{count}} persoon heeft deze rol. Geef die eerst een andere rol.',
    heldRoleKept_other: '{{count}} personen hebben deze rol. Geef ze eerst een andere rol.',
    saveError: 'De rol kon niet worden opgeslagen.',
    dialog: {
      titleAdd: 'Rol toevoegen',
      titleEdit: 'Rol bewerken',
      name: 'Naam',
      description: 'Omschrijving',
      nameRequired: 'Een rol heeft een naam nodig.',
      startFrom: 'Beginnen vanaf',
      startEmpty: 'Leeg beginnen',
      startFromHint: 'Neemt de pagina\'s en acties van die rol over als startpunt. Wat een nieuwe rol niet mag hebben, komt niet mee.',
    },
    removeDialog: {
      title: 'Rol verwijderen',
      message: '{{name}} verwijderen? De pagina\'s en acties van deze rol gaan mee. Niemand heeft hem.',
      remove: 'Verwijderen',
    },
    messages: {
      added: '{{name}} toegevoegd',
      updated: '{{name}} opgeslagen',
      removed: '{{name}} verwijderd',
    },
  },
  systemRoleList: {
    subtitle: 'De rollen waarvan de rollen van elke organisatie erven.',
    add: 'Rol toevoegen',
    edit: 'Rol bewerken',
    remove: 'Rol verwijderen',
    columns: {
      name: 'Naam',
      heldBy: 'Gegeven aan',
      enforced: 'Verplicht',
      extends: 'Breidt uit',
      description: 'Omschrijving',
    },
    everyOrganisation: 'Elke organisatie',
    notEnforced: 'Niet verplicht',
    root: 'Basis van alle rollen',
    enforcedKept: 'Elke organisatie heeft deze rol, dus hij kan niet weg.',
    baseKept: '{{names}} breiden deze rol uit, dus hij kan niet weg.',
    heldKept_one: 'De rol van {{count}} organisatie erft hiervan, dus hij kan niet weg.',
    heldKept_other: 'De rollen van {{count}} organisaties erven hiervan, dus hij kan niet weg.',
    saveError: 'De rol kon niet worden opgeslagen.',
    dialog: {
      titleAdd: 'Systeemrol toevoegen',
      titleEdit: 'Systeemrol bewerken',
      name: 'Naam',
      nameRequired: 'Een rol heeft een naam met letters of cijfers nodig.',
      nameLocked: 'Organisaties kennen deze rol bij zijn naam, dus die blijft.',
      description: 'Omschrijving',
      extends: 'Breidt uit',
      extendsHint: 'Hij kan krijgen wat deze rol heeft, en niets meer.',
      extendsRequired: 'Kies de rol die hij uitbreidt.',
      extendsLocked: 'Wat hij uitbreidt, ligt vast sinds hij is toegevoegd.',
      everywhere: 'Elke organisatie krijgt deze rol zodra je opslaat, zonder pagina\'s tot je die aanzet. Hij kan daarna niet meer weg.',
    },
    removeDialog: {
      title: 'Systeemrol verwijderen',
      message: '{{name}} verwijderen? Geen organisatie heeft hem en geen rol breidt hem uit.',
      remove: 'Verwijderen',
    },
    messages: {
      added: '{{name}} toegevoegd aan elke organisatie',
      updated: '{{name}} opgeslagen',
      removed: '{{name}} verwijderd',
    },
  },
  globalRoleList: {
    subtitle: 'De rollen van het beheer van het platform zelf.',
    columns: {
      name: 'Naam',
      heldBy: 'Gegeven aan',
      screens: 'Schermen',
    },
    screens: '{{held}} van {{total}} schermen',
  },
  look: {
    title: 'Symbool en kleuren',
    symbol: {
      title: 'Symbool',
      description: 'Staat voor ieder lid naast de naam van de tenant in de navigatiebalk. Het hoort bij de organisatie, dus al haar tenants tonen hetzelfde symbool.',
      preview: 'Zo staat het symbool in de navigatiebalk',
      none: 'Nog geen symbool. Leden zien alleen de naam van de tenant.',
      accepted: 'PNG of WebP, hooguit 512 KB en minstens 64 × 64 pixels.',
      choose: 'Kies een afbeelding',
      save: 'Symbool opslaan',
      saved: 'Symbool opgeslagen.',
      remove: 'Symbool verwijderen',
      removed: 'Symbool verwijderd.',
      refused: 'Dit bestand kan niet worden gebruikt. Kies een PNG- of WebP-afbeelding van hooguit 512 KB en minstens 64 × 64 pixels.',
      error: 'Het symbool kon niet worden opgeslagen. Probeer het opnieuw.',
    },
    profiles: {
      title: 'Kleurprofielen',
      description: 'Leden zien het standaardprofiel tot ze zelf een profiel kiezen. De standaardprofielen van MLP staan altijd naast jullie eigen profielen.',
      standard: 'Standaardprofiel van MLP',
      own: 'Profiel van deze tenant',
      default: 'Standaard',
      makeDefault: 'Maak standaard',
      defaultSaved: '{{name}} is nu het standaardprofiel.',
      edit: 'Kleuren aanpassen',
      history: 'Geschiedenis',
      add: 'Profiel toevoegen',
      newName: 'Naam van het profiel',
      create: 'Profiel opslaan',
      added: '{{name}} is toegevoegd als versie 1.',
      duplicateName: 'Deze tenant heeft al een profiel met die naam. Kies een andere naam.',
      loadError: 'De kleurprofielen konden niet worden geladen. Laad de pagina opnieuw om het nog eens te proberen.',
      saveError: 'De wijziging kon niet worden opgeslagen. Probeer het opnieuw.',
    },
    editor: {
      title: 'Kleuren van {{name}}',
      newTitle: 'Nieuw kleurprofiel',
      hexLabel: 'Hexwaarde van {{role}}',
      variants: 'Lichtere, hoofd- en donkerdere variant, met de tekstkleur op de hoofdvariant',
      textSample: 'Aa',
      contrastIntro: 'Met deze kleuren is tekst slecht leesbaar. Pas de kleur hieronder aan:',
      contrastFailure: '{{role}}, {{pairing}}: {{ratio}}:1, waar minstens {{required}}:1 nodig is',
      pairing: {
        textOnColour: 'tekst op deze kleur',
        linkOnPaper: 'als linktekst op wit',
        linkOnPage: 'als linktekst op de achtergrond van de pagina',
      },
      save: 'Opslaan als nieuwe versie',
      saved: 'Opgeslagen als versie {{version}}.',
      reset: 'Terug naar Meridian',
      close: 'Sluiten',
    },
    history: {
      title: 'Geschiedenis van {{name}}',
      version: 'Versie {{version}}',
      savedBy: '{{when}}, door {{who}}',
      savedAt: '{{when}}',
      current: 'In gebruik',
      rollBack: 'Terug naar deze versie',
      rolledBack: 'Teruggezet. Opgeslagen als versie {{version}}.',
      loadError: 'De geschiedenis kon niet worden geladen.',
      rollBackError: 'Het terugzetten kon niet worden opgeslagen. Probeer het opnieuw.',
    },
    preview: {
      title: 'Voorbeeld',
      navigationCurrent: 'Dashboard',
      navigationOther: 'Metingen',
      button: 'Opslaan',
      secondButton: 'Toevoegen',
      link: 'Een link',
      chart: 'Een meting over een week, met het doelbereik',
    },
    roles: {
      primary: {
        name: 'Hoofdkleur',
        hint: 'Navigatie, knoppen, links en focus',
      },
      secondary: {
        name: 'Tweede kleur',
        hint: 'Tweede knoppen en accenten',
      },
      success: {
        name: 'Binnen bereik',
        hint: 'Een waarde waar die hoort, en wat gelukt is',
      },
      warning: {
        name: 'Buiten bereik',
        hint: 'Een waarde die van het doel afwijkt',
      },
      error: {
        name: 'Fout',
        hint: 'Foutmeldingen, en wat nu aandacht vraagt',
      },
      info: {
        name: 'Informatie',
        hint: 'Neutrale meldingen',
      },
    },
    standard: {
      meridian: 'Meridian',
      lagune: 'Lagune',
      classic: 'Klassiek',
    },
    choice: {
      title: 'Kleurprofiel',
      description: 'Hoe de app er voor jou uitziet. Je keuze geldt zodra je je profiel opslaat, en gaat mee naar andere apparaten.',
      followTenant: 'Standaard van {{tenant}} ({{name}})',
      followMeridian: 'Standaard van MLP (Meridian)',
      loadError: 'De kleurprofielen konden niet worden geladen.',
    },
  },
  organisationPage: {
    people: 'Personen',
    notFoundTitle: 'Deze organisatie is niet gevonden',
    notFoundBody: 'Misschien is ze verwijderd, of klopt het adres niet.',
    loadFailedTitle: 'Deze organisatie kon niet worden gelezen',
    loadFailed: 'Probeer het zo opnieuw.',
    table: {
      name: 'Naam',
      tenant: 'Tenant',
      email: 'E-mail',
      since: 'Lid sinds',
    },
    addButton: 'Persoon toevoegen',
    added: '{{name}} is toegevoegd aan {{tenant}}',
    add: {
      title: 'Een persoon toevoegen aan {{organisation}}',
      tenant: 'Tenant',
      tenantRequired: 'Kies een tenant',
      person: 'Persoon',
      personRequired: 'Kies een persoon',
      signedInOnly: 'Alleen wie al eens heeft ingelogd, is te vinden.',
      nobody: 'Niemand met een account past hierbij. Iemand verschijnt na de eerste keer inloggen.',
      noTenant: 'Deze organisatie heeft nog geen tenant. Er kan dus niemand worden toegevoegd.',
      readFailed: 'De tenants of de personen konden niet worden gelezen.',
      save: 'Toevoegen',
      failed: 'De persoon kon niet worden toegevoegd.',
    },
  },
  programmePeople: {
    table: {
      name: 'Naam',
      email: 'E-mail',
      since: 'Ingeschreven sinds',
    },
    addButton: 'Deelnemer toevoegen',
    added: '{{name}} is ingeschreven',
    add: {
      title: 'Een deelnemer toevoegen aan {{programme}}',
      member: 'Lid',
      memberRequired: 'Kies een lid',
      membersOnly: 'Je kunt alleen leden kiezen die nog niet zijn ingeschreven.',
      nobody: 'Er is geen lid dat past en nog niet is ingeschreven.',
      membersFailed: 'De leden konden niet worden gelezen.',
      save: 'Toevoegen',
      failed: 'Het lid kon niet worden ingeschreven.',
    },
  },
  valueDetail: {
    title: 'Waar deze waarde vandaan komt',
    traceTitle: 'Herkomst van deze waarde',
    loading: 'De herkomst van deze waarde wordt gelezen',
    missing: 'Er is geen waarde met dit nummer.',
    failed: 'De herkomst van deze waarde kon niet worden gelezen.',
    retry: 'Opnieuw proberen',
    value: 'Waarde',
    time: 'Moment',
    notKnown: 'Meer is er niet bekend over deze waarde.',
    recorded: 'Zoals vastgelegd',
    code: 'Code',
    codeSystem: 'Codesysteem: {{system}}',
    source: 'Bron',
    sources: {
      manualInput: 'Door jou ingevoerd',
      deviceSync: 'Van een gekoppelde bron',
      uploaded: 'Uit een document',
      coachingSession: 'Van een coach',
    },
    shownAs: 'Getoond als',
    converted: 'Hoe het is omgerekend',
    noConversion: 'Niet omgerekend: getoond zoals vastgelegd.',
    conversion: {
      algebra: '1 {{from}} = {{factor}} {{to}}, bevestigd op {{date}}.',
      molarMass: '1 {{from}} = {{factor}} {{to}}, via de molaire massa van {{analyte}} ({{mass}} g/mol, bron: {{source}}), bevestigd op {{date}}.',
    },
    reference: 'Verwijzing',
    changedSince: 'Veranderd sindsdien',
    notChanged: 'De code is sindsdien niet veranderd.',
    laterRelease: 'Een latere uitgave heeft deze code veranderd nadat de waarde was vastgelegd.',
    change: '{{field}}: {{from}} → {{to}} ({{date}})',
    showFullOrigin: 'Volledige herkomst tonen',
    close: 'Sluiten',
    graphLabel: 'Metingen. Gebruik de pijltjestoetsen om te wisselen.',
    graphOpenHint: 'Druk op Enter om te openen.',
  },
  groupingLevels: {
    label: 'Hoe breed waarden meetellen',
    loading: 'De niveaus worden gelezen',
    loadFailed: 'De niveaus konden niet worden gelezen. Het opgeslagen niveau blijft zoals het is.',
    THIS_CODE: {
      name: 'Alleen deze code',
      help: 'Alleen waarden die onder precies deze code zijn vastgelegd tellen mee.',
    },
    ANY_METHOD: {
      name: 'Hetzelfde, op welke manier ook gemeten',
      help: 'Waarden van hetzelfde tellen mee, thuis of in de kliniek gemeten.',
    },
  },
};

export default { translation };
